const app = Vue.createApp({
	delimiters: ['${', '}'],
	data() {
		return {
			//Global
			currency: '£',
			showModal: { 0: false },
			modalFullScreen: { 0: false },
			modalClassText: { 0: false },
			menuOpen: false,
			subMenuOpen: [],
			isMobile: false,
			currentCountry: 'United Kingdom',
			flagSrc: 'united-kingdom.png',
			screenWidth: window.innerWidth,
			isCountryBannerOpen: localStorage.getItem('isCountryBannerOpen') === 'true',

			//Subscription Builder
			builderTitle: 'Select your Fresh Beer',
			builderButtonText: 'Add to bag',
			builderBeerCount: 0,
			builderBeerMax: 4,
			builderBeerSelected: [],
			builderSubscription: [],
			builderRunningTotal: 0.0,

			//Stepped Shop
			steppedShopError: false,
			steppedShopFilterToggle: false,
			steppedShopFilterCategories: [],
			steppedActiveSteps: [1],
			steppedItemsSelected: [],
			steppedItemsSelectedPrice: [],
			steppedSubscription: [],
			steppedItemsList: [],
			steppedItems2FPList: [],
			is2FPApplied: false,
			isCampaignApplied: false,
			steppedTotal: 0.0,
			steppedTotalSubs: 0.0,
			campDiscTotal: 0.0,
			steppedTabs: {
				'step-2': 'subs',
			},
			isSteppedAddToBagClick: false,
			steppedError: null,

			//Cart
			cartAddKey: '',
			cartAddTitle: '',
			cartLoaded: false,
			cartTitle: 'Your order’s in the bag',
			cartTotalItems: 0,
			cartHasPinter: false,
			cartData: { items: {} },
			cartDataOriginal: [],
			cartDataPinterOriginal: [],
			cartDataPT4: [],
			cartQty: {},
			cartAvailable: {},
			cartSellingPlan: {},
			cartOpen: false,
			cartGiftOptionSelected: false,
			cartFreeLineItemCount: 0,
			cartErrorMessage: [],
			cartInfoMessage: [],
			cartInfoPressMessage: [],
			cartDisableCheckout: false,
			cartLoading: false,
			isCartPage: false,
			cartItems2FPList: [],
			cartItemsSelected: [],
			cartItemsSelectedPrice: [],
			cartSubscription: [],
			cartAddons: [],

			//Pinter
			pinterVariant: { 0: 'pinter-black' },
			pinterVariantName: { 0: 'Pinter' },
			pinterVariantSubName: { 0: 'Black' },
			pinterVariantCost: { 0: '0.00' },
			pinterVariantOriginalCost: { 0: '0.00' },
			pinterVariantID: { 0: 0 },
			pinterVariantImage: { 0: null },
			/* redirect to fresh press selection */
			selectFreshPresh: true,

			//Related Tabs
			relatedTabActive: 1,

			//Accordion
			accordionRowActive: 0,

			//Tile
			faqList: [],
			tileActive: [],

			//Shop
			shopFilterCategories: false,
			shopFilterSortBy: false,
			shopFilterProductType: false,

			//FAQs
			faqsSearch: '',
			faqsData: [],

			//Account
			accountLogin: 'login',

			//UserUI
			userUiTab: 0,
			userUiBeerCount: {},
			userUiBeerMax: 4,
			userUiBeerSelected: {},
			userUiRunningTotal: 0.0,
			userUiCancellation: false,
			userUiPause: false,
			userUiPauseDuration: 1,
			userUiAddress: null,
			userUiTotalChanges: [],
			userUiTotalNew: [],
			userUiTotalCount: [],
			userUiTotalCountNew: [],
			userUiChoicesSubmitted: false,
			defaultPinterSelected: false,
			isCampVarAvailable: false,
			userUiPauseButton: true,

			// ?
			value: 0,

			// Age gate
			ageGateKeyName: 'ggagegate',
			ageGateKeyValue: 'verified',
			giftVoucherPopupKey: 'gift-check',
			giftVoucherPopupValue: 'show',
			previousItemCount: 'prev-item-count',
			previousItems: 'prev-items',

			// for pricing funnel campaign
			currProdVarLs: localStorage.getItem('currClickVariant'),
			// for subscription present
			hasCustomerSub: false,
			hasCartSub: false,
			// for core pinters
			updatingCorePinterCart: false,
			maxPressesInPinter: 3,
			maxPressesInCoPinter: 1,
		};
	},
	created() {
		this.cartGetData()
			.then(() => {
				this.cartCheckFreeSubs(true);
				this.cartCheckPaidSubs(true);
				this.cartSetTotal();
				this.cartSetHasPinter();
				this.cartSetPinterBundles();
				this.cartChecks();
				this.setOriginalPrice();
			})
			.then(() => {
				this.cartLoaded = true;
			});
	},
	mounted() {
		// website redirects to correct location
		let params = new URLSearchParams(document.location.search);
		let country = params.get('country');
		if (country === 'us') {
			this.setCookie('country', 'United States', 365);
			if (window.location.hostname.includes('pinter.co.uk')) {
				window.location.href = `https://${window.location.hostname.replace(
					'pinter.co.uk',
					'pinter.com'
				)}?country=us`;
			}
		} else if (country === 'uk') {
			this.setCookie('country', 'United Kingdom', 365);
		}
		// set consent cookies and age gate in subdomains
		const consentCookie = this.getCookie('cookieconsent_preferences_disabled');
		if (consentCookie === '' || consentCookie)
			this.setCookie('consent_preferences_disabled', consentCookie, 365);
		// end cookies and age gate in subdomains
		this.appRedirect();
		this.setJWT();
		this.forumRedirect();
		this.loadFaqs();
		this.defaultPinter();
		this.cartQtyLoad();
		this.userUiLoadData();
		this.userUiTotalOrderLoad();
		this.clickOutsideOfGiftPopup();
		this.clickOutsideOfNotifyMeModal();
		this.clickOutsideModal();
		setTimeout(() => {
			this.updateHeaderAndContentPosition();
		}, 100);
		//this.resetAllRadio();

		//this.preventForm();

		// update isCartPage flag
		if (window.isCartPage) {
			this.isCartPage = true;
		}

		// for pricing funnel campaign
		// check pricing funnel campaign in on or off
		//window.isPricingFunnelOn = false;

		if (window.isPricingFunnelOn) {
			this.setLsForPricingFunnelCamp();
			if (window.productObj || this.currProdVarLs) {
				this.setBuyControlsPinterPrice();
			}
			if (window.productCardList && window.productCardList.length > 0) {
				for (var i = 0; i < productCardList.length; i++) {
					this.setProductCardPinterPrice(productCardList[i]);
				}
			}
		} else {
			localStorage.removeItem('pricing_campaign');
		}

		//get pricing_campaign value from local storage
		let pricing_campaign = this.getWithExpiry('pricing_campaign');
		pricing_campaign = 'PT3';
		this.is2FPApplied = false;
		// if(pricing_campaign == "PT4"){
		//     this.is2FPApplied = true;
		// }
		// else{
		//     this.is2FPApplied = false;
		// }
		if (
			pricing_campaign == 'PT2' ||
			pricing_campaign == 'PT3' ||
			pricing_campaign == 'PT1' ||
			pricing_campaign == 'PT4'
		) {
			this.isCampaignApplied = true;
		} else {
			this.isCampaignApplied = false;
		}

		if (document.getElementById('tile-main')) {
			this.fetchFaqs();
		}

		this.setCookieHasSub(customer_id_shopify); //Verify If Customer Has Subscription

		if (this.windowHash !== '') {
			this.scrollTo(window.location.hash.replace('#', ''));
		}

		if (this.windowHash === '#recover') {
			this.accountLogin = 'forgot';
		}

		// header reappear on scroll up
		// let prevScrollpos = window.pageYOffset;

		// window.onscroll = function() {

		//     let currentScrollPos = window.pageYOffset;

		//     if (prevScrollpos > currentScrollPos) {
		//         document.getElementById("header").style.top = "0";
		//     } else {
		//         document.getElementById("header").style.top = "-100%";

		//     }
		//     prevScrollpos = currentScrollPos;

		// }

		// let scrollpos = window.scrollY

		// const header = document.getElementById("header")
		// const header_height = header.offsetHeight

		// const add_class_on_scroll = () => header.classList.add("header-hide")
		// const remove_class_on_scroll = () => header.classList.remove("header-hide")

		// window.addEventListener('scroll', function() {
		//     scrollpos = window.scrollY;

		//     if (scrollpos >= header_height){
		//         add_class_on_scroll()
		//     }else {
		//         if(header.classList.contains('header-hide')){
		//             remove_class_on_scroll()
		//         }
		//     }
		// })

		//

		const body = document.body;
		const scrollUp = 'scroll-up';
		const scrollDown = 'scroll-down';
		let lastScroll = 0;

		window.addEventListener('scroll', () => {
			const currentScroll = window.pageYOffset;
			if (currentScroll <= 100) {
				body.classList.remove(scrollUp);
				return;
			}

			if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
				// down
				body.classList.remove(scrollUp);
				body.classList.add(scrollDown);
			} else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
				// up
				body.classList.remove(scrollDown);
				body.classList.add(scrollUp);
			}
			lastScroll = currentScroll;
		});

		/* header reappear on scroll up */

		// reset all radio buttons of color selectors
		if (document.querySelectorAll('.color-selector input[type=radio]')) {
			setTimeout(function () {
				document.querySelectorAll('.color-selector input[type=radio]').forEach((radioBtn) => {
					radioBtn.checked = false;
				});
			}, 50);
		}
	},
	watch: {
		'steppedItemsList.length'() {
			this.subsStepErrors();
		},
		'steppedTabs.step-2'() {
			this.subsStepErrors();
		},
		isCountryBannerOpen() {
			setTimeout(() => {
				this.updateHeaderAndContentPosition();
			}, 100);
		},
	},
	computed: {
		windowHash() {
			return window.location.hash;
		},
		builderTotal() {
			return this.builderRunningTotal.toFixed(2);
		},
		builderBeerCountPlural() {
			return this.builderBeerCount == 1 ? '' : 's';
		},
		hasSteppedErrors() {
			return !!this.steppedError;
		},
		//Cart computed
		cartCurrencySymbol() {
			return document.getElementById('cart-data').dataset.currency || '';
		},
		cartPinterItems() {
			if (this.cartData.items && this.cartData.items.length) {
				return this.cartData.items.filter(
					(item) => item.product_type == 'Pinter' || item.product_type == 'Co-Pinter'
				);
			}
			return [];
		},
		hasPinter() {
			return this.cartPinterItems.length;
		},
		cartPinterStrictItems() {
			if (this.cartData.items && this.cartData.items.length) {
				return this.cartData.items.filter((item) => item.product_type == 'Pinter');
			}
			return [];
		},
		hasStrictPinter() {
			return this.cartPinterStrictItems.length;
		},
		cartHas2FPConditionsMet() {
			var conditionsMet = true;

			var has2FPPress = false;
			this.cartData.items.forEach((item) => {
				if (item.product_type == 'Press' && item.variant_title == 'PT4') {
					has2FPPress = true;
				}
			});

			if (has2FPPress) {
				conditionsMet = false;
				this.cartData.items.forEach((item) => {
					if (item.product_type == 'Pinter' && item.variant_title == 'PT4') {
						conditionsMet = true;
					}
				});
			}
			return conditionsMet;
		},
		cartHasCorrect2FPCounts() {
			var conditionsMet = true;

			var has2FPPress = false;
			var count2FPPress = 0;
			this.cartData.items.forEach((item) => {
				if (item.product_type == 'Press' && item.variant_title == 'PT4') {
					has2FPPress = true;
					count2FPPress += item.quantity;
				}
			});

			if (has2FPPress && count2FPPress > 1) {
				conditionsMet = false;
			}

			return conditionsMet;
		},
		cartSubsItems() {
			if (this.cartData.items && this.cartData.items.length) {
				return this.cartData.items.filter((item) => item.variant_title == 'Subs');
			}
		},
		cartSubsItemsFree() {
			if (this.cartData.items && this.cartData.items.length) {
				return this.cartData.items.filter((item) => (item.variant_title == 'Subs') & (item.final_price == 0));
			}
			return [];
		},
		cartSubsItemsPaid() {
			if (this.cartData.items && this.cartData.items.length) {
				return this.cartData.items.filter((item) => (item.variant_title == 'Subs') & (item.final_price > 0));
			}
			return [];
		},
		hasFreePress() {
			return this.cartSubsItemsFree.length || false;
		},
		hasPaidSubPress() {
			let value = false;
			if (this.cartSubsItemsPaid.length > 0) {
				this.cartInfoPressMessage = [];
				this.cartInfoPressMessage.push(
					'Only your most recent Fresh Beer Club selection (up to 4 drinks) will appear in your basket. To change, increase or decrease your current Fresh Beer Club choices, <a href="/collections/fresh-beer-club">click here</a>.'
				);
				value = this.cartSubsItemsPaid.length;
			}
			return value;
		},
		cartNonPinterItems() {
			if (this.cartData.items && this.cartData.items.length) {
				return this.cartData.items.filter(
					(item) => item.product_type != 'Pinter' && item.product_type != 'Co-Pinter'
				);
			}
		},
		cartPressItems() {
			if (this.cartData.items && this.cartData.items.length) {
				return this.cartData.items.filter((item) => item.product_type == 'Press');
			}
			return [];
		},
		hasPress() {
			var pressFound = false;
			this.cartData.items.forEach((item) => {
				if (item.product_type == 'Press') {
					pressFound = true;
				}
			});
			return pressFound;
		},
		//End of Cart Computed

		faqsFiltered() {
			return this.faqsData.filter((faq) => {
				if (faq.id !== 'undefined' && this.faqsSearch.length) {
					return (
						faq.title.toLowerCase().includes(this.faqsSearch.toLowerCase()) ||
						faq.content.toLowerCase().includes(this.faqsSearch.toLowerCase())
					);
				}
			});
		},
		builderDiscountToApply() {
			if (this.builderBeerCount == 2) {
				return 1;
			} else if (this.builderBeerCount == 3) {
				return 2;
			} else if (this.builderBeerCount == 4) {
				return 3;
			}
			return 0;
		},
		builderDiscountToApplyRemove() {
			if (this.builderBeerCount == 1) {
				return 1;
			} else if (this.builderBeerCount == 2) {
				return 2;
			} else if (this.builderBeerCount == 3) {
				return 3;
			}
			return 0;
		},
		steppedTotalDiscount() {
			return this.steppedTotal - this.steppedTotalSubs - this.campDiscTotal;
		},
		steppedHasFreePacks() {
			//console.log(this.steppedItemsSelectedPrice)
			return this.steppedItemsSelectedPrice.filter((item) => item == 0).length;
		},
		hasCartItem() {
			return (id) => !!this.cartData.items.find((item) => item.product_id === id);
		},
	},
	beforeDestroy() {
		if (typeof window !== 'undefined') {
			window.removeEventListener('resize', this.onResize, { passive: true });
		}
	},
	beforeMount() {
		this.onResize();
		window.addEventListener('resize', this.onResize, { passive: true });
	},
	methods: {
      replaceQuotes(str) {
        return str.replaceAll("&#39;", "'");
      },
		showLocationBanner() {
			localStorage.setItem('isCountryBannerOpen', true);
			this.isCountryBannerOpen = true;
		},
		updateHeaderAndContentPosition() {
			const header = document.getElementById('header');
			const content = document.getElementById('content');
			const bannerExtra = document.getElementsByClassName('aph_bar_bar')[0];
			if (header) {
				if (this.isCountryBannerOpen) header.style.marginTop = window.innerWidth > 991 ? '95px' : '165px';
				else header.style.marginTop = '0px';
			}
			if (content) {
				if (this.isCountryBannerOpen) content.style.marginTop = window.innerWidth > 991 ? '95px' : '165px';
				else content.style.marginTop = '0px';
			}
			this.updateBannerExtraPosition(bannerExtra);
		},
		updateBannerExtraPosition(bannerExtra) {
			console.log('banner extra', bannerExtra);
			if (bannerExtra) {
				if (this.isCountryBannerOpen) bannerExtra.style.top = window.innerWidth > 991 ? '175px' : '80px';
				else bannerExtra.style.top = '80px';
			} else
				setTimeout(
					function () {
						const bannerExtra = document.getElementsByClassName('aph_bar_bar')[0];
						if (this.isCountryBannerOpen) bannerExtra.style.top = window.innerWidth > 991 ? '175px' : '80px';
						else bannerExtra.style.top = '80px';
					}.bind(this),
					1000
				);
		},
		changeCountry(country) {
			this.currentCountry = country;
			this.flagSrc = country.toLowerCase().replace(' ', '-') + '.png';
		},
		closeCountryBanner() {
			localStorage.setItem('isCountryBannerOpen', false);
			this.isCountryBannerOpen = false;
		},
		submitCountry() {
			this.closeCountryBanner();
			if (this.currentCountry === 'United Kingdom') this.setCookie('country', 'United Kingdom', 365);
			else {
				this.setCookie('country', 'United States', 365);
				window.location.href = `https://${window.location.hostname.replace(
					'.pinter.co.uk',
					'.pinter.com'
				)}?country=us`;
			}
		},
		onResize() {
			this.isMobile = window.innerWidth < 1024;
			this.defaultPinterSelected = this.isMobile;
		},
		async preventRegisterForm(event) {
			// event.preventDefault();
			const firstName = this.validate_first_name(event);
			const lastName = this.validate_last_name(event);
			const date = this.validate_bDate(event);
			const email = this.validate_email(event);
			const pwd = this.validate_password(event);
			const phone = this.validate_phone(event);
			const duplicated = await this.isPhoneDuplicated(phone);
			const isAccountNotRegistered = await this.isAccountNotRegistered();
			if (firstName && lastName && date && email && pwd && phone && duplicated && isAccountNotRegistered)
				document.getElementById('submit_register_form')?.click();
		},
		validate_phone(event) {
			let phoneNumber = document.getElementById('phone_number');
			let phoneErr = document.getElementById('phoneErr');

			if ((phoneNumber.value &&
					/^(((0044\s?\d{4}|\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/.test(
						phoneNumber.value
					))
			) {
				phoneErr.innerHTML = '';
				return true;
			} else {
				phoneErr.innerHTML = 'Please enter a valid number';
				event.preventDefault();
				return false;
			}
		},
		cartItemExists(id) {
			return (
				!!this.cartData.items.find((item) => item.product_id === id) &&
				!this.cartAddons.find((addon) => addon.id === id)
			);
		},
		isCartAddonsEmpty(numberOfAddons) {
			return this.cartAddons.length >= 4 || this.cartAddons.length > numberOfAddons || numberOfAddons === 0;
		},
		async isPhoneDuplicated(isPhoneValid) {
			let phoneNumber = document.getElementById('phone_number');
			let phoneErr = document.getElementById('phoneErr');
			if (phoneNumber.value && phoneNumber.value !== '' && isPhoneValid) {
				const response = await fetch(
					`${window.pinsaUrl}/api/v1/customers/validate_phone?phone=${encodeURIComponent(phoneNumber.value)}`,
					{
						method: 'GET',
						headers: {
							'Content-Type': 'application/json',
							'Access-Control-Allow-Origin': '*',
						},
						credentials: 'include',
					}
				);
				let value = undefined;
				await response.json().then((resp) => {
					value = resp.valid;
				});
				if (!value) {
					phoneErr.innerHTML =
						'It seems this number already exists in our system. Please check the number carefully to ensure it is correct. If you have any concerns, please contact our support team.';
					return false;
				} else {
					phoneErr.innerHTML = '';
					return true;
				}
			} else return true;
		},
		validate_first_name(event) {
			// first name -----------------------------
			let fName = document.getElementById('first_name');
			let fNameErr = document.getElementById('fNameErr');

			if ((fName && fName.value == '') || fName.value == null) {
				fNameErr.innerHTML = 'Please enter a first name';
				event.preventDefault();
				return false;
			} else {
				fNameErr.innerHTML = '';
				return true;
			}
		},
		validate_last_name(event) {
			// last name ------------------------------
			let lName = document.getElementById('last_name');
			let lNameErr = document.getElementById('lNameErr');

			// last name
			if ((lName && lName.value == '') || lName.value == null) {
				lNameErr.innerHTML = 'Please enter a last name';
				event.preventDefault();
				return false;
			} else {
				lNameErr.innerHTML = '';
				return true;
			}
		},
		validate_bDate(event) {
			// birth date ---------------------------------------
			let bDate = document.getElementById('bDate');
			let bDateErr = document.getElementById('bDateErr');
			// birth date
			if ((bDate && bDate.value == '') || bDate.value == null) {
				bDateErr.innerHTML = 'Please enter a date';
				event.preventDefault();
				return false;
			} else {
				bDateErr.innerHTML = '';
			}
			// birth date
			if ((bDate && bDate.value == '') || bDate.value < 1 || bDate.value > 31 || bDate.value == null) {
				bDateErr.innerHTML = 'Please enter a valid date';
				event.preventDefault();
				return false;
			} else {
				bDateErr.innerHTML = '';
			}

			// birth month -------------------------------------------------
			let bMonth = document.getElementById('bMonth');
			let bMonthErr = document.getElementById('bMonthErr');
			// birth month
			if ((bMonth && bMonth.value == '') || bMonth.value < 1 || bMonth.value > 12 || bMonth.value == null) {
				bMonthErr.innerHTML = 'Please enter a valid month';
				event.preventDefault();
				return false;
			} else {
				bMonthErr.innerHTML = '';
			}

			// birth year ----------------------------------
			let bYear = document.getElementById('bYear');
			let bYearErr = document.getElementById('bYearErr');
			// birth year
			if (bYear && bYear.value > new Date().getFullYear() - 18) {
				bYearErr.innerHTML = 'Please enter a valid year (You should be at least 18 years old.)';
				event.preventDefault();
				return false;
			} else if (
				(bYear && bYear.value == '') ||
				bYear.value < new Date().getFullYear() - 100 ||
				bYear.value > new Date().getFullYear() - 18 ||
				bYear.value == null
			) {
				bYearErr.innerHTML = 'Please enter a valid year';
				event.preventDefault();
				return false;
			} else {
				bYearErr.innerHTML = '';
			}
			return true;
		},
		validate_email(event) {
			// email -----------------------------------
			let email = document.getElementById('email');
			let emailErr = document.getElementById('emailErr');
			// email
			if (
				(email && email.value == '') ||
				!/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
					email.value
				)
			) {
				emailErr.innerHTML = 'Please enter a valid email';
				event.preventDefault();
				return false;
			} else {
				emailErr.innerHTML = '';
				return true;
			}
		},
		validate_password(event) {
			// password --------------------------------------
			let password = document.getElementById('password');
			let passwordErr = document.getElementById('passwordErr');
			// password
			if ((password && password.value == '') || password.value == null) {
				passwordErr.innerHTML = 'Please enter a password';
				event.preventDefault();
				return false;
			} else {
				passwordErr.innerHTML = '';
				return true;
			}
		},
		validateForgotPassword(event) {
			// email
			let email = document.getElementById('forgotPWEmail');
			let forgotPWEmailErr = document.getElementById('forgotPWEmailErr');
			if (email && email.value == '') {
				forgotPWEmailErr.innerHTML = 'Please enter a valid email';
				event.preventDefault();
			} else {
				forgotPWEmailErr.innerHTML = '';
			}
		},
		async isAccountNotRegistered() {
			let email = document.getElementById('email');
			let emailErr = document.getElementById('emailErr');
			try {
				const response = await fetch(
					`${window.pinsaUrl}/api/v1/customers/account_activation_url?email=${encodeURIComponent(email.value)}`,
					{
						method: 'GET',
						headers: {
							'Content-Type': 'application/json',
							'Access-Control-Allow-Origin': '*',
						},
						credentials: 'include',
					}
				);
				const resp = await response.json();
				if (resp.status === 'enabled') {
					window.location.href = '/account/login';
					return false;
				} else if (resp.account_activation_url && resp.status === 'disabled') {
					window.location.href = resp.account_activation_url;
					return false;
				}
				return true;
			} catch (error) {
				emailErr.innerHTML = 'An error occurred while processing your request. Please try again later.';
				return false;
			}
		},
		submitHiddenForm(form, baseUrl) {
			let email = document.getElementById('email');
			let password = document.getElementById('password');
			fetch(`${baseUrl}/api/v1/sessions`, {
				method: 'POST',
				headers: {
					'X-Auth-Type': 'jwt',
					'Content-Type': 'application/json',
					'Access-Control-Allow-Origin': '*',
				},
				credentials: 'include',
				body: JSON.stringify({ email: email.value, password: password.value }),
			})
				.then((response) => response.json())
				.then((response) => {
					document.getElementById(form).click();
				});
		},
		preventLogin(event) {
			// event.preventDefault();
			this.validateLoginEmail(event);
			this.validateLoginPassword(event);
		},
		validateLoginEmail(event) {
			// login email
			let loginEmail = document.getElementById('email');
			let loginEmailErr = document.getElementById('loginEmailErr');
			// login email
			if (loginEmail && loginEmail.value == '') {
				loginEmailErr.innerHTML = 'Please enter a valid email';
				event.preventDefault();
			} else {
				loginEmailErr.innerHTML = '';
			}
		},
		validateLoginPassword(event) {
			// login password
			let loginPassword = document.getElementById('password');
			let loginPasswordErr = document.getElementById('loginPasswordErr');
			// login password
			if ((loginPassword && loginPassword.value == '') || loginPassword.value == null) {
				loginPasswordErr.innerHTML = 'Please enter a password';
				event.preventDefault();
			} else {
				loginPasswordErr.innerHTML = '';
			}
		},
		logout(baseUrl) {
			fetch(`${baseUrl}/api/v1/sessions`, {
				method: 'DELETE',
				credentials: 'include',
			}).then((response) => {
				window.location = '/account/logout';
			});
		},
		setCookieHasSub(custId) {
			if (custId == null || custId == undefined) {
			} else {
				return new Promise((resolve, reject) => {
					fetch(window.subAppCustSubStatusApiUrl, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							shopify_id: parseInt(custId),
						}),
					})
						.then((response) => response.json())
						.then((data) => {
							if (data.status) {
								var details = this.cartData.items;
								for (var i = 0; i < details.length; i++) {
									var variant_title = details[i].variant_title;
									if (variant_title && variant_title.includes('Subs')) {
										this.hasCustomerSub = true;
										this.hasCartSub = true;
										break;
									}
								}
							}
							resolve(true);
						})
						.catch((error) => {
							reject(error);
						});
				});
			}
		},
		menuToggle() {
			this.menuOpen = this.menuOpen ? false : true;
		},
		subMenuToggle(menu) {
			let menuIndex = this.subMenuOpen.indexOf(menu);
			if (menuIndex === -1) {
				this.subMenuOpen.push(menu);
			} else {
				this.subMenuOpen.splice(menuIndex, 1);
			}
		},

		// ***************
		// Cart Methods
		// ***************
		cartChecks() {
			this.cartDisableCheckout = false;

			if (this.cartData.items.length) {
				if (this.hasStrictPinter) {
					if (!this.hasPress) {
						this.cartErrorMessage.push(
							'Pinters can only be purchased with at least one Pinter Pack. <a href="/collections/fresh-beer" class="button tiny"><span>Select Pinter Pack</span></a>'
						);
						this.cartDisableCheckout = true;
					}
				}
				if (this.hasFreePress) {
					if (!this.hasPinter) {
						this.cartErrorMessage.push(
							'Free subscription packs may only be purchased with a Pinter. <a href="/pages/shop" class="button tiny"><span>Select Pinter</span></a>'
						);
						this.cartDisableCheckout = true;
					}
				}
				if (this.is2FPApplied) {
					if (!this.cartHas2FPConditionsMet) {
						this.cartErrorMessage.push(
							'Free Fresh Presses may only be purchased with a Pinter. <a href="/pages/shop" class="button tiny"><span>Select Pinter</span></a>'
						);
						this.cartDisableCheckout = true;
						return;
					}
					if (!this.cartHasCorrect2FPCounts) {
						this.cartErrorMessage.push(
							'Only one free Fresh Press may be purchased with each Pinter. <a href="/pages/shop" class="button tiny"><span>Select Pinter</span></a>'
						);
						this.cartDisableCheckout = true;
					}
				}
			}
		},
		strictPintersInItems(items) {
			if (!items) return [];
			return items.filter((item) => item.type == 'Pinter');
		},
		pintersInItems(items) {
			if (!items) return [];
			return items.filter((item) => item.type == 'Pinter' || item.type == 'Co-Pinter');
		},
		pressesInItems(items) {
			if (!items) return [];
			return items.filter((item) => item.product_type === 'Press');
		},
		freePressesInItems(items) {
			if (!items) return [];
			return items.filter((item) => item.type == 'subscription' && item.price == 0);
		},
		async cartCheckForCheapestPress() {
			if (!this.isCartPage) {
				return;
			}
			if (this.is2FPApplied) {
				this.cartDataOriginal = [];
				this.cartDataPT4 = [];
				var isOneOff = false;
				var oneOffHandle = [];
				var noqty = 0;
				var existingPT4 = null;
				var existingPT4Handle = null;
				for (var i = 0; i < this.cartData.items.length; i++) {
					var item = this.cartData.items[i];
					var temp = {};
					if (item.product_type === 'Press' && item.variant_title !== 'Subs') {
						if (item.variant_title == 'PT4') {
							existingPT4 = item.id;
							existingPT4Handle = item.handle;
						}
						isOneOff = true;
						noqty += item.quantity;
						temp.handle = item.handle;
						temp.quantity = item.quantity;
						oneOffHandle.push(temp);
					}
				}
				this.cartLoading = false;
				if (isOneOff) {
					this.cartLoading = true;
					//Getting only one off press handle
					this.getOneOffVariantFromHandle(oneOffHandle, noqty).then((arrOneOff) => {
						var arrCheapestPrice = arrOneOff;
						//Sorting the cheapest to TOP
						if (arrCheapestPrice.length > 1) {
							arrCheapestPrice = arrOneOff.sort(({ price: a }, { price: b }) => a - b);
						}
						//Logic if PT4 already Present
						var PT4actualPrice = 0;
						var oneOffQty = 0;
						var oneOffVariantId = null;
						//Checking for existing PT4 fresh press with one off
						for (var i = 0; i < arrOneOff.length; i++) {
							if (arrOneOff[i].handle == existingPT4Handle) {
								oneOffVariantId = arrOneOff[i].id;
								PT4actualPrice = arrOneOff[i].price;
								oneOffQty++;
							}
						}
						//If PT4 press present is not cheapest
						if (PT4actualPrice == 0 || PT4actualPrice > arrOneOff[0].price) {
							var isupdate = true;
							if (oneOffVariantId == null) {
								isupdate = false;
							}
							//Updating one off with the actual quantity if other cheap press found
							this.updatingFreshPress(oneOffVariantId, oneOffQty, isupdate).then(() => {
								//Existing PT4 removed when cheap press found
								this.updatingFreshPress(existingPT4, 0, true).then(() => {
									//Finally replacing Lowest Price For PT4
									this.replacingCheapestPT4(arrCheapestPrice);
								});
							});
						} else {
							this.cartLoading = false;
						}
					});
				}
			}
		},
		replacingCheapestPT4(arrCheapestPrice) {
			var oneoffHandle = arrCheapestPrice[0].handle;
			//Getting one off and filtering PT4 of cheapest
			this.getOriginalVariantByProductHandle(oneoffHandle).then((itemsPT4) => {
				var cheapQty = 0;
				var cheapPrice = arrCheapestPrice[0].price;
				for (var i = 0; i < arrCheapestPrice.length; i++) {
					if (cheapPrice == arrCheapestPrice[i].price) {
						cheapQty++;
					}
				}
				this.updatingFreshPress(arrCheapestPrice[0].id, cheapQty - 1, true).then((data) => {
					var items = [
						{
							id: itemsPT4[0].id,
							quantity: 1,
						},
					];
					this.addPT4(items);
				});
			});
		},
		//Updating press details to store
		updatingFreshPress(id, qty, isremove) {
			let payload = {
				updates: {},
			};
			payload['updates'][id] = qty;
			return new Promise((resolve, reject) => {
				if (!isremove || id === null) {
					resolve(true);
				} else {
					fetch('/cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(payload),
					})
						.then((response) => response.json())
						.then((data) => {
							resolve(data);
						})
						.catch((error) => {
							reject(error);
						});
				}
			});
		},
		//Adding PT4 to the store
		addPT4(items) {
			return new Promise((resolve, reject) => {
				if (items[0].id === null) {
					resolve(true);
				} else {
					let formData = {
						items: items,
					};
					fetch('/cart/add.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(formData),
					})
						.then((response) => response.json())
						.then((data) => {
							this.cartGetData().then(() => {
								this.cartSetTotal();
								this.cartSetHasPinter();
								this.cartSetPinterBundles();
								this.cartLoading = false;
							});
						})
						.catch((error) => {
							reject(error);
						});
				}
			});
		},
		//Getting one off press handle
		async getOneOffVariantFromHandle(oneOffHandle, noqty) {
			var items = [];
			for (var i = 0; i < oneOffHandle.length; i++) {
				var temp = await this.handelOneoff(oneOffHandle[i].handle, oneOffHandle[i].quantity);
				for (var j = 0; j < oneOffHandle[i].quantity; j++) {
					items.push(temp);
				}
				if (items.length === noqty) {
					return items;
				}
			}
		},
		//Fetching one off press handle from the store
		handelOneoff(handle, quantity) {
			return new Promise((resolve, reject) => {
				let url = '/products/' + handle + '.json';
				fetch(url, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
					.then((response) => response.json())
					.then((data) => {
						var variants = data.product.variants;
						for (var i = 0; i < variants.length; i++) {
							var temp = {};
							if (variants[i].title !== 'PT4' && variants[i].title !== 'Subs') {
								temp.id = variants[i].id;
								temp.price = variants[i].price;
								temp.handle = handle;
								break;
							}
						}
						resolve(temp);
					})
					.catch((error) => {
						console.error('Error:', error);
					});
			});
		},
		//Getting handle for cheapest one off and filtering PT4
		getOriginalVariantByProductHandle(handle) {
			return new Promise((resolve, reject) => {
				let url = '/products/' + handle + '.json';
				return fetch(url, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
					.then((response) => response.json())
					.then((data) => {
						var items = [];
						var variants = data.product.variants;
						//filter PT4 varaint
						for (var i = 0; i < variants.length; i++) {
							var temp = {};
							if (variants[i].title == 'PT4') {
								temp.product_id = variants[i].product_id;
								temp.id = variants[i].id;
								temp.quantity = 1;
								items.push(temp);
							}
						}
						resolve(items);
					})
					.catch((error) => {
						console.error('Error:', error);
					});
			});
		},
		getPinterVariantByProductHandle(handle) {
			let url = '/products/' + handle + '.json';
			return fetch(url, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((data) => {
					//console.log(data);
					return data;
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},
		calculateCartGrandTotal() {
			let grandTotal = 0;

			// calculation the total
			this.cartData.items.forEach((x) => {
				grandTotal += x.price;
			});

			// update in carData object
			this.cartData.total_price = grandTotal;
		},
		cartAddItemTo2FPList(item, plan = false, price = 0, img, title, sub_title, type, originalPrice = 0, qty) {
			let priceComp = 0;
			if (!plan) {
				priceComp = price;
			}

			this.cartItemsSelected.push(item);
			this.cartItemsSelectedPrice.push(priceComp);
			this.cartSubscription.push(plan);

			let object = {
				id: item,
				img: img,
				title: title,
				sub_title: sub_title,
				price: price,
				original_price: originalPrice,
				type: type,
				quantity: qty,
			};

			this.cartItems2FPList.push(object);
		},
		convertVariantToCartItemObj(variantObj, originalValObj) {
			if (variantObj.product_id != null && originalValObj.product_id != null) {
				if (variantObj.product_id == originalValObj.product_id) {
					variantObj.id = originalValObj.id;
					variantObj.variant_id = originalValObj.id;
					variantObj.variant_title = originalValObj.title;
					variantObj.price = parseInt(originalValObj.price) * 100;
					variantObj.line_price = parseInt(originalValObj.price) * 100;
					variantObj.discounted_price = parseInt(originalValObj.price) * 100;
					variantObj.final_line_price = parseInt(originalValObj.price) * 100;
					variantObj.final_price = parseInt(originalValObj.price) * 100;
					variantObj.original_price = parseInt(originalValObj.price) * 100;
					variantObj.original_line_price = parseInt(originalValObj.price) * 100;
					variantObj.variant_options = [originalValObj.title];
					variantObj.quantity = 1;
				}
			}
			return variantObj;
		},
		setOriginalPrice() {
			if (!this.isCampaignApplied) {
				return;
			}
			this.cartLoading = true;
			// get all PT3 items in array
			let allPT3Pinters = this.cartData.items.filter(
				(item) => item.variant_title === 'PT3' && item.product_type === 'Pinter'
			);

			if (allPT3Pinters.length > 0) {
				// collect all promises for original value
				let promisesAll = [];
				for (let i = 0; i < allPT3Pinters.length; i++) {
					let item = allPT3Pinters[i];
					let oneoffHandle = item.handle;
					let promise = this.getPinterVariantByProductHandle(oneoffHandle);
					promisesAll.push(promise);
				}
				Promise.all(promisesAll)
					.then((values) => {
						//console.log(values);
						//this.cartDataPinterOriginal = [];
						for (let i = 0; i < values.length; i++) {
							let item = values[i];
							let originalVar = item.product.variants.filter((item) => item.title === 'Pinter 2')[0];
							this.cartDataPinterOriginal.push(originalVar);
						}

						//console.log(this.cartDataPinterOriginal);
						for (let i = 0; i < this.cartData.items.length; i++) {
							let cartItem = this.cartData.items[i];
							for (let j = 0; j < this.cartDataPinterOriginal.length; j++) {
								let cartOrgItem = this.cartDataPinterOriginal[j];
								if (cartItem.product_id == cartOrgItem.product_id) {
									cartItem.original_price = parseInt(cartOrgItem.price) * 100;
								}
							}
						}
						this.cartLoading = false;
					})
					.catch(function (err) {
						this.cartLoading = false;
						throw err;
					});
			} else {
				this.cartLoading = false;
			}
		},
		cartLineLimiterCheck(item) {
			if (item.title === 'FREE') {
				return false;
			}

			if (item.line_price == 0 && this.cartFreeLineItemCount >= 2) {
				return false;
			}
			return true;
		},
		cartCheckFreeSubs(firstLoad) {
			if (this.cartSubsItemsFree) {
				var removeList = [];
				var freeCheck = 0;
				var countLoop = 0;

				this.cartSubsItemsFree.forEach((item) => {
					countLoop++;
					if (freeCheck > 2) {
						removeList.push({ id: item.id, quantity: 0 });
						return;
					}
					freeCheck += item.quantity;
					if (freeCheck > 2) {
						var qtyEffect = freeCheck - 2;
						removeList.push({ id: item.id, quantity: item.quantity - qtyEffect });
					}
				});

				this.cartFreeLineItemCount = freeCheck;

				if (freeCheck > 2 && this.cartSubsItemsFree.length == countLoop) {
					if (firstLoad) {
						this.cartErrorMessage.push(
							'Only 2 free pinter packs allowed per order - Your bag has been updated'
						);
					}
					let payload = {
						updates: {},
					};
					removeList.forEach((item) => {
						payload['updates'][item.id] = item.quantity;
					});

					fetch('/cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(payload),
					})
						.then((response) => response.json())
						.then((data) => {
							this.cartData = data;
						})
						.catch((error) => {
							console.error('Error:', error);
						});
				}
			}
		},
		cartCheckPaidSubs(firstLoad) {
			if (this.cartSubsItemsPaid) {
				var removeList = [];
				var paidCheck = 0;
				var countLoop = 0;

				this.cartSubsItemsPaid.forEach((item) => {
					countLoop++;
					if (paidCheck > 4) {
						removeList.push({ id: item.id, quantity: 0 });
						return;
					}
					paidCheck += item.quantity;
					if (paidCheck > 4) {
						var qtyEffect = paidCheck - 4;
						removeList.push({ id: item.id, quantity: item.quantity - qtyEffect });
					}
				});

				this.cartFreeLineItemCount = paidCheck;

				if (paidCheck > 4 && this.cartSubsItemsPaid.length == countLoop) {
					if (firstLoad) {
						this.cartErrorMessage.push(
							'Only 4 subscription pinter packs allowed per order - Your bag has been updated'
						);
					}
					let payload = {
						updates: {},
					};
					removeList.forEach((item) => {
						payload['updates'][item.id] = item.quantity;
					});

					fetch('/cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(payload),
					})
						.then((response) => response.json())
						.then((data) => {
							this.cartData = data;
						})
						.catch((error) => {
							console.error('Error:', error);
						});
				}
			}
		},
		cartGetData() {
			return fetch('/cart.js', {
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((data) => {
					this.cartData = data;
					//console.log(this.cartData)
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},
		cartOpenToggle() {
			this.cartOpen = this.cartOpen ? false : true;
			if (this.cartOpen) {
				document.body.classList.add('locked');
			} else {
				document.body.classList.remove('locked');
			}
		},
		cartAddToBag(id, type, price) {
			let data = [];
			let cartItemCount = this.cartPinterItems.length;

			if (type == 'Pinter' || type == 'Co-Pinter') {
				//console.log(this.cartQty[id])
				for (let qty = 1; qty <= this.cartQty[id]; qty++) {
					data.push({
						id: id,
						quantity: 1,
						form_type: 'product',
						properties: { Ref: cartItemCount },
					});
					cartItemCount++;
				}
			} else {
				data.push({
					selling_plan: this.cartSellingPlan[id],
					id: id,
					quantity: this.cartQty[id],
					form_type: 'product',
				});
			}

			let formData = {
				items: data,
			};

			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			})
				.then((response) => {
					this.cartGetData().then(() => {
						this.scrollTo('app');
						this.cartSetTotal();
						this.cartSetHasPinter();
						this.cartSetPinterBundles();
						this.cartOpenToggle();
					});
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},
		getCartItem(id) {
			return this.cartData.items.find((item) => item.product_id === id);
		},
		cartAddToBagFromCart(id, productId, quantity, scroll = false) {
			let data = [];

			data.push({
				id: id,
				quantity: quantity,
			});

			this.cartAddons.push({
				id: productId,
				quantity: quantity,
			});

			let formData = {
				items: data,
			};

			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			})
				.then((response) => {
					if (window.snowplow) {
						const payload = {
							page_name: 'Cart Summary - Brewer recommendations',
							action: 'fresh press selected',
							details: {
								fresh_press: productId,
								quantity: quantity,
							},
						};
						window.snowplow('trackSelfDescribingEvent', {
							event: {
								schema: 'iglu:co.uk.pinter/user_click_event/jsonschema/1-0-1',
								data: payload,
							},
						});
					}
					this.cartGetData().then(() => {
						if (scroll) this.scrollTo('app');
						this.cartSetTotal();
						this.cartSetHasPinter();
						this.cartSetPinterBundles();
					});
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},
		// ***************
		// Gift Voucher Methods
		// ***************
		pinterOutofStockGiftVoucher() {
			//localStorage.removeItem(this.giftVoucherPopupKey);
			const giftCookie = sessionStorage.getItem(this.giftVoucherPopupKey);
			return giftCookie === this.giftVoucherPopupValue;
		},
		pinterProceedToBuy() {
			document.getElementById('gift-voucher').style.display = 'none';
			sessionStorage.setItem(this.giftVoucherPopupKey, this.giftVoucherPopupValue);
			return true;
		},
		clickOutsideOfGiftPopup() {
			var $this = this;
			document.addEventListener('mouseup', function (e) {
				var element = document.getElementById('gift-voucher');

				if (element) {
					var container = element.getElementsByClassName('modal-container')[0];
					if (container && !container.contains(e.target)) {
						$this.pinterProceedToBuy();
					}
				}
			});
		},
		// ***************
		// Gift Voucher Methods Ends
		// ***************
		// ***************
		// Back in stock notification methods starts
		// ***************
		openNotifyMeModal(varId, prodTitle, prodId) {
			document.getElementById('back-in-stock-notify-modal').style.display = 'block';
			document.getElementById('current-variant-id').value = varId;
			document.getElementById('current-product-id').value = prodId;
			document.getElementById('current-product-title').value = prodTitle;
			document.getElementsByClassName('NotifyMeEmailMainWrapper')[0].style.display = 'block';
			document.getElementsByClassName('NotifyMeEmailSuccessMsgWrapper')[0].style.display = 'none';
			document.getElementById('notifyMeEmailId').value = '';
			document.getElementById('notifyMeEmailId').focus();
		},
		closeNotifyMeModal() {
			document.getElementById('back-in-stock-notify-modal').style.display = 'none';
		},
		clickOutsideOfNotifyMeModal() {
			var $this = this;
			document.addEventListener('mouseup', function (e) {
				var element = document.getElementById('back-in-stock-notify-modal');
				if (element) {
					var container = element.getElementsByClassName('modal-container')[0];
					if (container && !container.contains(e.target)) {
						$this.closeNotifyMeModal();
					}
				}
			});
		},
		closeSubscriptionMeModal() {
			document.getElementsByClassName('modal-box')[0].style.display = 'none';
		},
		clickOutsideModal() {
			let $this = this;
			if (document.getElementsByClassName('modal-box')[0]) {
				document.addEventListener('mouseup', function (e) {
					let modalBox = document.getElementsByClassName('modal-box')[0];
					let container = modalBox.getElementsByClassName('modal-container')[0];
					container && !container.contains(e.target) ? $this.closeSubscriptionMeModal() : '';
				});
			}
		},
		// resetAllRadio(){
		//     // var radio = document.querySelectorAll('.shop-stepped-section__product-detail input[type=radio]:checked');
		//     // radio.checked = false;
		//     var nodeList = document.querySelectorAll(".shop-stepped-section .color-selector input[type=radio]");
		//     for (var i = 0; i < nodeList.length; i++) {
		//         nodeList[i].checked = false;
		//     }
		// },
		validateEmail(emailId) {
			var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (emailId.match(mailformat)) {
				return true;
			} else {
				return false;
			}
		},
		addNotifyMeEntry() {
			var varId = document.getElementById('current-variant-id').value;
			var prodId = document.getElementById('current-product-id').value;
			var prodTitle = document.getElementById('current-product-title').value;
			var emailId = document.getElementById('notifyMeEmailId').value;
			var data = {
				email: emailId,
				variant_ext_id: varId,
			};
			fetch(window.pinterServiceStockEntryApiUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			})
				.then((response) => {
					if (response.status === 200) return response.json();
					else {
						document.getElementsByClassName('notifyMeEmailErrorMsg')[0].style.display = 'flex';
						document.getElementsByClassName('notifyMeEmailErrorMsg')[0].innerHTML = 'Something went wrong.';
						return undefined;
					}
				})
				.then((data) => {
					if (data) {
						document.getElementsByClassName('NotifyMeEmailMainWrapper')[0].style.display = 'none';
						document.getElementsByClassName('NotifyMeEmailSuccessMsgWrapper')[0].style.display = 'block';
						document.getElementById('NotifyMeEmailSuccessMsgText').innerHTML =
							'Thank you. We’ll notify you when this item is back in stock';
						document.getElementsByClassName('notifyMeEmailErrorMsg')[0].style.display = 'none';
						document.getElementsByClassName('notifyMeEmailIdTxtWrapper')[0].classList.remove('error');
					}
				})
				.catch((error) => {
					document.getElementsByClassName('notifyMeEmailErrorMsg')[0].style.display = 'flex';
					document.getElementsByClassName('notifyMeEmailErrorMsg')[0].innerHTML = 'Something went wrong.';
					//console.error('Error:', error);
				});
			return true;
		},
		// ***************
		// Back in stock notification methods ends
		// ***************
		cartQtyPreAdd(variantID) {
			this.cartQty[variantID]++;
		},
		cartQtyPreRemove(variantID) {
			this.cartQty[variantID]--;

			if (this.cartQty[variantID] < 0) {
				this.cartQty[variantID] = 0;
			}
		},
		cartQtyLoad() {
			const variantsToSet = document.getElementsByClassName('data-cart-qty');
			const variantsToSetKeys = Object.keys(variantsToSet);

			if (variantsToSetKeys.length > 0) {
				variantsToSetKeys.forEach((objectKey) => {
					let variantID = variantsToSet[objectKey].getAttribute('data-variantID');
					let sellingPlanID = variantsToSet[objectKey].getAttribute('data-sellingPlanID');
					let available = variantsToSet[objectKey].getAttribute('data-available');
					this.cartQty[variantID] = 1;
					this.cartSellingPlan[variantID] = sellingPlanID;
					this.cartAvailable[variantID] = available;
				});
			}
		},
		cartSetTotal() {
			this.cartTotalItems = this.cartData.item_count;
			this.snowPlowTrackCartActivity();
		},
		cartSetPinterBundlesAddItemAction(addKey, title) {
			if (this.cartPinterItems) {
				if (this.cartPinterItems.length > 1) {
					this.showModal['bundler'] = true;
					this.cartAddKey = addKey;
					this.cartAddTitle = title;
					this.modalClassText['bundler'] = true;
					return;
				}
				this.cartSetPinterBundlesAddItem(addKey);
			}
		},
		cartSetPinterBundlesAddItem(addKey, pinterKey = null) {
			let unbundledItems = [];
			let reversed = [...this.cartPinterItems];

			reversed = reversed.reverse();

			if (reversed) {
				reversed.forEach(async (item, key) => {
					const bundleKey = 'cart_bundle_' + key + '_' + item.sku;
					const bundleExcKey = 'cart_bundle_exc_' + key + '_' + item.sku;
					let bundledItemsExclude = [];
					bundledItemsExclude = (await JSON.parse(localStorage.getItem(bundleExcKey))) || bundledItemsExclude;

					bundledItemsExclude.splice(bundledItemsExclude.indexOf(addKey), 1);
					localStorage.setItem(bundleExcKey, JSON.stringify(bundledItemsExclude));

					if (pinterKey == key || pinterKey == null) {
						let bundledItems = [];
						originalBundledItems = (await JSON.parse(localStorage.getItem(bundleKey))) || bundledItems;
						originalBundledItems.push(addKey);

						localStorage.setItem(bundleKey, JSON.stringify(originalBundledItems));

						this.cartReload();
						this.showModal['bundler'] = false;
					}
				});
			}
		},
		cartSetPinterBundlesRemoveItem(excludeKey) {
			let reversed = [...this.cartPinterItems];
			reversed = reversed.reverse();

			//Add the key to ALL exclude arrays to stop the cart adding it to another bundle!
			if (reversed) {
				reversed.forEach((item, key) => {
					const bundleExcKey = 'cart_bundle_exc_' + key + '_' + item.sku;
					const bundleKey = 'cart_bundle_' + key + '_' + item.sku;
					let bundledItemsExclude = [];
					let bundledItems = [];
					bundledItemsExclude = JSON.parse(localStorage.getItem(bundleExcKey)) || bundledItemsExclude;
					bundledItemsExclude.push(excludeKey);
					localStorage.setItem(bundleExcKey, JSON.stringify(bundledItemsExclude));

					bundledItems = JSON.parse(localStorage.getItem(bundleKey)) || bundledItems;
					bundledItems.splice(bundledItems.indexOf(excludeKey), 1);
				});

				this.cartReload();
			}
		},
		subsStepErrors() {
			const strictPinters = this.strictPintersInItems(this.steppedItemsList).length;
			const presses = this.pressesInItems(this.steppedItemsList).length;
			const pinters = this.pintersInItems(this.steppedItemsList).length;
			const freePresses = this.freePressesInItems(this.steppedItemsList).length;
			if (this.steppedTabs['step-2'] === 'subs' || strictPinters > presses) {
				this.steppedError = null;
				if (presses == 0 && freePresses == 0) {
					this.steppedError =
						'Select a pack of Fresh Beer to go with your Pinter. <a href="#step-2" style="margin: 5px 0;" @click.prevent="scrollTo(\'step-2\')" class="button tiny"><span>Select Your Fresh Beer</span></a>';
				}
				if (strictPinters == 0) {
					if (freePresses > 0 && presses == 0) {
						this.steppedError =
							'Select a Pinter to go with your fresh beer subscription. <a href="#step-1" style="margin: 5px 0;" @click.prevent="scrollTo(\'step-1\')" class="button tiny"><span>Select Pinter</span></a>';
					} else {
						this.steppedError =
							'Select a Pinter to go with your fresh beer. <a href="#step-1" style="margin: 5px 0;" @click.prevent="scrollTo(\'step-1\')" class="button tiny"><span>Select Pinter</span></a>';
					}
				}
				setTimeout(
					function () {
						var element = document.getElementsByClassName('stepped-error-class')[0];
						if (element) element.innerHTML = this.steppedError;
					}.bind(this),
					250
				);
			} else this.steppedError = null;
		},
		cartSetPinterBundles() {
			let localBundlesItems = this.cartLocalBundles();

			if (localBundlesItems.length) {
				this.cartManualSetPinterBundles(localBundlesItems);
			} else {
				this.cartAutoSetPinterBundles();
			}
		},
		cartLocalBundles() {
			let globalBundledItemCount = [];
			let reversed = [...this.cartPinterItems];

			reversed = reversed.reverse();

			if (reversed) {
				reversed.forEach((item, key) => {
					const bundleKey = 'cart_bundle_' + key + '_' + item.sku;
					const bundleExcKey = 'cart_bundle_exc_' + key + '_' + item.sku;
					let bundledItems = [];
					let bundledItemsExclude = [];

					originalBundledItems = JSON.parse(localStorage.getItem(bundleKey)) || bundledItems;
					bundledItemsExclude = JSON.parse(localStorage.getItem(bundleExcKey)) || bundledItemsExclude;

					this.cartNonPinterItems.forEach((nonItem) => {
						for (let step = 1; step <= nonItem.quantity; step++) {
							const nonItemKey = nonItem.sku + '_' + step;
							if (
								originalBundledItems.indexOf(nonItemKey) !== -1 ||
								bundledItemsExclude.indexOf(nonItemKey) !== -1
							) {
								globalBundledItemCount.push(nonItemKey);
							}
						}
					});
				});
			}

			return globalBundledItemCount;
		},
		cartManualSetPinterBundles(globalBundledItems) {
			let unbundledItems = [];
			let reversed = [...this.cartPinterItems];
			let updatedCount = 0;

			reversed = reversed.reverse();

			if (reversed) {
				reversed.forEach((item, key) => {
					const bundleKey = 'cart_bundle_' + key + '_' + item.sku;
					const bundleExcKey = 'cart_bundle_exc_' + key + '_' + item.sku;
					let bundledItems = [];
					let bundledItemsExclude = [];
					let bundleCount = 0;
					let properties = {};
					let shouldSkip = false;

					originalBundledItems = JSON.parse(localStorage.getItem(bundleKey)) || bundledItems;
					bundledItemsExclude = JSON.parse(localStorage.getItem(bundleExcKey)) || bundledItemsExclude;

					properties['Ref'] = key;

					this.cartNonPinterItems.forEach((nonItem) => {
						if (shouldSkip) {
							return;
						}
						for (let step = 1; step <= nonItem.quantity; step++) {
							const nonItemKey = nonItem.sku + '_' + step;
							let currentKey = originalBundledItems.indexOf(nonItemKey);

							if (currentKey !== -1 && bundledItemsExclude.indexOf(nonItemKey) === -1) {
								//Set as a line item property
								properties[currentKey] = nonItem.sku;
								bundledItems.push(nonItemKey);
								bundleCount++;
								var max = this.maxPressesInPinter;
								if (item.product_type == 'Co-Pinter') {
									max = this.maxPressesInCoPinter;
								}
								if (bundleCount == max) {
									shouldSkip = true;
									return;
								}
							}
						}
					});

					if (JSON.stringify(properties) !== JSON.stringify({ ...item.properties })) {
						reversed[key].properties = properties;

						//Get the line number for the item in the cart - add one on because the line numbers in shopify start at 1 not 0
						const checkIndex = this.cartData.items.findIndex((checkItem) => checkItem.key == item.key) + 1;

						let data = {
							line: checkIndex,
							properties: properties,
						};

						fetch('/cart/change.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify(data),
						})
							.then((response) => response.json())
							.then((data) => {
								console.log('updated!');
							})
							.catch((error) => {
								console.error('Error:', error);
							});

						localStorage.setItem(bundleKey, JSON.stringify(bundledItems));
					}

					updatedCount++;
				});
				if (updatedCount == reversed.length) {
				}
			}
		},
		cartAutoSetPinterBundles() {
			let unbundledItems = [];
			let globalBundledItems = [];

			let reversed = [...this.cartPinterItems];

			reversed = reversed.reverse();

			if (reversed) {
				reversed.forEach((item, key) => {
					const bundleKey = 'cart_bundle_' + key + '_' + item.sku;
					const bundleExcKey = 'cart_bundle_exc_' + key + '_' + item.sku;
					let bundledItems = [];
					let bundledItemsExclude = [];
					let bundleCount = 0;
					let properties = {};
					let shouldSkip = false;

					originalBundledItems = JSON.parse(localStorage.getItem(bundleKey)) || bundledItems;
					bundledItemsExclude = JSON.parse(localStorage.getItem(bundleExcKey)) || bundledItemsExclude;

					properties['Ref'] = key;

					this.cartNonPinterItems.forEach((nonItem) => {
						if (shouldSkip) {
							return;
						}
						for (let step = 1; step <= nonItem.quantity; step++) {
							const nonItemKey = nonItem.sku + '_' + step;

							if (
								unbundledItems.indexOf(nonItemKey) === -1 &&
								globalBundledItems.indexOf(nonItemKey) === -1
							) {
								unbundledItems.push(nonItemKey);
								if (bundledItemsExclude.indexOf(nonItemKey) === -1) {
									//Set as a line item property
									properties[bundleCount + 1] = nonItem.sku;

									unbundledItems.splice(unbundledItems.indexOf(nonItemKey), 1);
									bundledItems.push(nonItemKey);
									globalBundledItems.push(nonItemKey);
									bundleCount++;
									var max = this.maxPressesInPinter;
									if (item.product_type == 'Co-Pinter') {
										max = this.maxPressesInCoPinter;
									}
									if (bundleCount == max) {
										shouldSkip = true;
										return;
									}
								}
							}
						}
					});

					if (this.cartNonPinterItems.length == 0) {
						bundledItems = [];
					}

					if (JSON.stringify(bundledItems) !== originalBundledItems) {
						this.cartPinterItems[key].properties = properties;

						//Get the line number for the item in the cart - add one on because the line numbers in shopify start at 1 not 0
						const checkIndex = this.cartData.items.findIndex((checkItem) => checkItem.key == item.key) + 1;

						const data = {
							line: checkIndex,
							properties: properties,
						};

						fetch('/cart/change.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify(data),
						})
							.then((response) => response.json())
							.then((data) => {
								this.cartData = data;
								this.cartCheckFreeSubs(false);
								this.cartCheckPaidSubs(false);
							})
							.catch((error) => {
								console.error('Error:', error);
							});

						localStorage.setItem(bundleKey, JSON.stringify(bundledItems));
					}
				});
			}
		},
		cartItemInPinter(key) {
			let status = false;
			let reversed = [...this.cartPinterItems];

			reversed = reversed.reverse();
			if (reversed) {
				reversed.forEach((item, index) => {
					const bundleKey = 'cart_bundle_' + index + '_' + item.sku;
					let originalBundledItems = JSON.parse(localStorage.getItem(bundleKey)) || '';

					if (item.properties) {
						keys = Object.keys(originalBundledItems);

						keys.forEach((properties, propertiesKey) => {
							if (originalBundledItems[properties] == key) {
								status = true;
							}
						});
					}
				});
			}
			return status;
		},
		cartItemInPinterLastItem(key) {
			let status = false;
			let reversed = [...this.cartPinterItems];
			this.cartInfoMessage = [];

			reversed = reversed.reverse();
			if (reversed) {
				reversed.forEach((item, index) => {
					const bundleKey = 'cart_bundle_' + index + '_' + item.sku;
					let originalBundledItems = JSON.parse(localStorage.getItem(bundleKey)) || '';

					if (item.properties) {
						keys = Object.keys(originalBundledItems);

						keys.forEach((properties, propertiesKey) => {
							// We also check the keys length here to stop
							// the remove button being shown if the item
							// is the only item in the pinter box
							// (Only for pinters - Co-Pinter can ship with no pack)

							if (item.product_type == 'Pinter') {
								if (originalBundledItems[properties] == key && keys.length <= 1) {
									status = true;
								}
							} else {
								if (originalBundledItems[properties] == key) {
									status = false;
								}
							}
						});
					}
				});
			}
			// if (status) {
			//     this.cartInfoMessage.push('Pinters can only be purchased with at least one pinter pack in the Pinter Box.');
			// }
			return status;
		},
		cartPinterProperties(sku, key) {
			let reversed = [...this.cartPinterItems];

			reversed = reversed.reverse();

			if (reversed && reversed.length) {
				const qtyRecord = [];
				const item = reversed.filter((item, itemKey) => item.sku == sku && itemKey == key);
				const bundleKey = 'cart_bundle_' + key + '_' + item[0].sku;
				let bundledItems = [];
				originalBundledItems = JSON.parse(localStorage.getItem(bundleKey)) || bundledItems;

				if (item[0] && item[0].properties) {
					const properties = [];
					const currentProperties = Object.keys(item[0].properties);
					if (currentProperties.length > 0) {
						originalBundledItems.forEach((objectKey) => {
							const propertyMeta = objectKey.split('_');
							if (propertyMeta) {
								const matchingItem = this.cartData.items.find(
									(matchingItem) => matchingItem.sku == propertyMeta[0]
								);
								if (matchingItem != undefined) {
									properties.push({
										id: matchingItem.id,
										title: matchingItem.title,
										sku: matchingItem.sku,
										key: propertyMeta[1],
									});
								}
							}
						});
						if (properties.length > 0) {
							return properties;
						}
					}
				}
			}
			return false;
		},
		hasCartPinterProperties(sku, key) {
			return Object.keys(this.cartPinterProperties(sku, key)).length;
		},
		cartSetHasPinter() {
			if (this.cartData.items) {
				return Object.keys((this.cartData?.items ?? []).filter((item) => item.product_type === 'Pinter'))
					.length;
			}
			return false;
		},
		cartSetHasPinterSpace(type) {
			if (this.cartPinterItems) {
				return Object.keys(
					this.cartPinterItems.filter((item) => {
						var max = this.maxPressesInPinter;
						if (item.product_type == 'Co-Pinter') {
							max = this.maxPressesInCoPinter;
						}
						return Object.keys(item.properties).filter((key) => key != 'Ref').length < max;
					})
				).length;
			}
			return false;
		},
		cartHasPinterSpace(pinterKey) {
			if (this.cartPinterItems) {
				return Object.keys(
					this.cartPinterItems.filter((item) => {
						if (item.key == pinterKey) {
							var max = this.maxPressesInPinter;
							if (item.product_type == 'Co-Pinter') {
								max = this.maxPressesInCoPinter;
							}
							return Object.keys(item.properties).filter((key) => key != 'Ref').length < max;
						}
					})
				).length;
			}
			return false;
		},
		moneyFormat(amount) {
			return this.cartCurrencySymbol + (amount / 100).toFixed(2);
		},
		cartReload() {
			this.cartGetData()
				.then(() => {
					this.cartErrorMessage = [];
					this.cartCheckFreeSubs(true);
					this.cartCheckPaidSubs(true);
					this.cartSetTotal();
					this.cartSetHasPinter();
					this.cartSetPinterBundles();
					this.cartChecks();
				})
				.then(() => {
					this.cartLoaded = true;
				});
		},
		cartPinterItemIndexByKey(key) {
			let reversed = [...this.cartPinterItems];
			let indexFound = null;

			reversed = reversed.reverse();

			for (let index = 0; index < reversed.length; index++) {
				if (reversed[index].key === key) {
					indexFound = index;
					break;
				}
			}

			return indexFound;
		},
		alertClose($this) {
			$this.target.closest('.alert').classList.add('hide');
		},

		// ***************
		// End of Cart Methods
		// ***************

		subscriptionVariants() {
			const variants = [];
			const builderBeerSelected = this.builderBeerSelected;
			this.builderSubscription.forEach(function (entry, key) {
				const found = variants.findIndex((variantCheck) => variantCheck.id == entry);

				if (found >= 0) {
					variants[found].quantity++;
				} else {
					const variant = {
						id: builderBeerSelected[key],
						quantity: 1,
						selling_plan: entry,
					};

					variants.push(variant);
				}
			});

			return variants;
		},
		removeBeer(variantID, subscription, cost) {
			const removeIndex = this.builderBeerSelected.indexOf(variantID);
			this.builderBeerCount--;
			this.builderRunningTotal = this.builderRunningTotal - cost / 100;
			this.builderBeerSelected.splice(removeIndex, 1);
			this.builderSubscription.pop();
		},
		addBeer(variantID, subscription, cost) {
			this.builderBeerCount++;
			this.builderRunningTotal = this.builderRunningTotal + cost / 100;
			this.builderBeerSelected.push(variantID);
			this.builderSubscription.push(subscription);
		},
		countVariant(variantID) {
			return this.builderBeerSelected.filter((v) => v === variantID).length;
		},
		addToBag() {
			if (this.hasFreePress || this.hasPaidSubPress) {
				fetch('/cart/clear.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
				})
					.then((response) => response.json())
					.then((data) => {
						this.addToBagRun();
					})
					.catch((error) => {
						console.error('Error:', error);
					});
			} else {
				this.addToBagRun();
			}
		},
		addToBagRun() {
			let formData = {
				items: this.subscriptionVariants(),
			};

			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			})
				.then((res) => res.json())
				.then((result) => {
					return (location.href = '/cart');
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},
		clearCart() {
			this.cartLoading = true;
			fetch('/cart/clear.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((responseData) => {
					this.cartReload();
					document.body.scrollTop = 0;
					document.documentElement.scrollTop = 0;
					this.cartLoading = false;
				})
				.catch((error) => {
					console.error('Error:', error);
					this.cartLoading = false;
				});
			//return location.href = '/cart/clear';
		},
		cartQtyUpdate(id, qty) {
			let payload = {
				updates: {},
			};

			payload['updates'][id] = qty;

			fetch('/cart/update.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(payload),
			})
				.then((response) => response.json())
				.then((data) => {
					this.cartData = data;
					this.cartErrorMessage = [];
					this.cartInfoMessage = [];
					this.cartDisableCheckout = false;
					//this.cartCheckForCheapestPress();
					this.cartCheckFreeSubs(false);
					this.cartCheckPaidSubs(false);
					this.cartChecks();
					this.cartSetTotal();
					this.setOriginalPrice();
				})
				.catch((error) => {
					console.error('Error:', error);
				});

			return false;
		},
		cartQtyUpdateFromCart(id, productId, oldQty, qty) {
			if (window.snowplow) {
				const payload = {
					page_name: 'Cart Summary - Brewer recommendations',
					action: `fresh press quantity ${oldQty > qty ? 'de' : 'in'}creased`,
					details: {
						fresh_press: productId,
						new_quantity: qty,
						old_quantity: oldQty,
					},
				};
				if (qty === 0) {
					payload['action'] = 'fresh press unselected';
					const element = this.cartAddons.find((addon) => addon.id === id);
					const index = this.cartAddons.indexOf(element);
					this.cartAddons.splice(index, 1);
				}
				window.snowplow('trackSelfDescribingEvent', {
					event: {
						schema: 'iglu:co.uk.pinter/user_click_event/jsonschema/1-0-1',
						data: payload,
					},
				});
			}
			let payload = {
				updates: {},
			};

			payload['updates'][id] = qty;

			return fetch('/cart/update.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(payload),
			})
				.then((response) => response.json())
				.then((data) => {
					this.cartData = data;
					this.cartErrorMessage = [];
					this.cartInfoMessage = [];
					this.cartDisableCheckout = false;
					this.cartCheckFreeSubs(false);
					this.cartCheckPaidSubs(false);
					this.cartChecks();
					this.cartSetTotal();
					this.setOriginalPrice();
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},
		secureCheckoutClick() {
			if (this.cartAddons.length > 0) {
				if (window.snowplow) {
					const payload = {
						page_name: 'Cart Summary - Brewer recommendations',
						action: 'recommended products selected (secure checkout)',
						details: {
							products: this.cartAddons,
						},
					};
					window.snowplow('trackSelfDescribingEvent', {
						event: {
							schema: 'iglu:co.uk.pinter/user_click_event/jsonschema/1-0-1',
							data: payload,
						},
					});
				}
			}
			document.getElementById('secure-checkout')?.click();
		},
		defaultPinter() {
			const pintersToSet = document.getElementsByClassName('default-pinter-data');
			const pintersToSetKeys = Object.keys(pintersToSet);
			if (pintersToSetKeys.length > 0) {
				pintersToSetKeys.forEach((objectKey) => {
					let productID = pintersToSet[objectKey].getAttribute('data-default-productID');
					this.pinterVariant[productID] = pintersToSet[objectKey].getAttribute('data-default-title');
					this.pinterVariantName[productID] =
						pintersToSet[objectKey].getAttribute('data-default-title-human');
					this.pinterVariantSubName[productID] = pintersToSet[objectKey].getAttribute(
						'data-default-sub-title-human'
					);
					this.pinterVariantID[productID] = pintersToSet[objectKey].getAttribute('data-default-variantID');
					this.pinterVariantCost[productID] =
						pintersToSet[objectKey].getAttribute('data-default-variantcost');
					this.pinterVariantOriginalCost[productID] =
						pintersToSet[objectKey].getAttribute('data-default-originalcost');
					this.pinterVariantImage[productID] = pintersToSet[objectKey].getAttribute('data-default-image');
				});
			}
		},
		updatePinterVariant(
			variantName,
			variantNameHuman = false,
			variantSubNameHuman = false,
			variantCost = false,
			originalCost = false,
			variantID = 0,
			productID = 0,
			image = null,
			dataProductID = null
		) {
			//get pricing_campaign value from local storage
			var pricing_campaign = this.getWithExpiry('pricing_campaign');

			//if pricing_campaign not set, get it from query string or call api and set it randomly
			if (pricing_campaign === null) {
				this.pinterVariant[productID] = variantName;
				this.pinterVariantName[productID] = variantNameHuman;
				this.pinterVariantSubName[productID] = variantSubNameHuman;
				this.pinterVariantCost[productID] = variantCost;
				this.pinterVariantOriginalCost[productID] = originalCost;
				this.pinterVariantID[productID] = variantID;
				this.pinterVariantImage[productID] = image;
				this.defaultPinterSelected = true;
			} else {
				let selectedProduct = window.productList.filter(function (item) {
					return item.id == dataProductID;
				});
				let campVar = selectedProduct[0].variants.filter(function (item) {
					return item.title == pricing_campaign;
				});

				this.pinterVariant[productID] = variantName;
				this.pinterVariantName[productID] = variantNameHuman;
				this.pinterVariantSubName[productID] = variantSubNameHuman;
				this.pinterVariantCost[productID] = campVar[0].price;
				this.pinterVariantOriginalCost[productID] = variantCost;
				this.pinterVariantID[productID] = campVar[0].id;
				this.pinterVariantImage[productID] = image;
				this.defaultPinterSelected = true;
				this.isCampVarAvailable = campVar[0].available;
				//console.log(campVar[0]);
				setTimeout(() => {
					if (pricing_campaign === 'PT2' || pricing_campaign === 'PT3') {
						if (document.getElementById('original-price')) {
							document.getElementById('original-price').className = 'discount';
						}
						if (document.getElementById('original-savings')) {
							document.getElementById('original-savings').className = '';
						}
					}
					if (pricing_campaign === 'PT4') {
						if (document.getElementById('discount-fresh-press')) {
							document.getElementById('discount-fresh-press').className = '';
						}
					}
				}, 50);
			}
		},
		isPremiumPinter(productID) {
			return this.pinterVariant[productID] === 'pinter-pure-finish';
		},
		validateSteppedShop(fbcMember) {
			if (!fbcMember) {
				const premiumPinter = this.steppedItemsList.filter((item) => item.sub_title == 'pure finish');
				if (premiumPinter.length > 0 && !this.hasSubscriptionVariants()) {
					return false;
				}
			}

			return true;
		},
		relatedTabActivate(activate) {
			this.relatedTabActive = activate;
			document.getElementsByClassName('related-products__overflow')[0]
				? (document.getElementsByClassName('related-products__overflow')[0].scrollLeft = 0)
				: null;
		},
		getGiftDiscountTotal(glassPrice) {
			let discount = 0;

			if (this.hasPinterVariants()) {
				discount += glassPrice * (this.steppedVariantByType('Pinter').length * 2);
			}

			return discount;
		},
		getSteppedDiscountTotal(glassPrice) {
			let discount = 0;

			if (this.hasSubscriptionVariants()) {
				discount += this.steppedTotalSubs;
			}
			if (this.isCampaignApplied || this.is2FPApplied) {
				discount += this.campDiscTotal;
			}

			discount += this.getGiftDiscountTotal(glassPrice);

			return discount;
		},
		getSteppedSubTotal(glassPrice) {
			let total = 0;

			total += this.steppedTotal;

			total += this.getGiftDiscountTotal(glassPrice);

			return total;
		},
		hasPinterVariants() {
			const variants = this.steppedVariantByType('Pinter');

			if (variants.length > 0) {
				return true;
			}

			// For every variant over 1, subtract 100 pence
			return false;
		},
		accordionRowActivate(activate, addWindowHash = true) {
			this.accordionRowActive = this.accordionRowActive === activate ? 0 : activate;
			if (addWindowHash) {
				// Push state to prevent immediate scrolling
				history.pushState(null, null, '#' + activate);
			}
		},
		recommendedModalShow(beerId = '', fullScreen = false, classText = false, id = 0) {
			if (window.snowplow) {
				const payload = {
					page_name: 'Cart Summary - Brewer recommendations',
					action: 'beer modal opened',
					details: {
						product_id: beerId,
					},
				};
				window.snowplow('trackSelfDescribingEvent', {
					event: {
						schema: 'iglu:co.uk.pinter/user_click_event/jsonschema/1-0-1',
						data: payload,
					},
				});
			}
			this.modalShow(fullScreen, classText, id);
		},
		modalShow(fullScreen = false, classText = false, id = 0) {
			this.modalFullScreen[id] = fullScreen ? true : false;
			this.modalClassText[id] = classText ? true : false;
			this.showModal[id] = true;
			// remove body scroll
			document.body.classList.add('no-scroll');
			// hide navbar when a modal is opened
			var mainTag = document.getElementsByTagName('main')[0];
			if (mainTag) mainTag.classList.add('increase-zindex');
		},
		modalClose(id = 0) {
			this.modalFullScreen[id] = false;
			this.modalClassText[id] = false;
			this.showModal[id] = false;
			document.body.classList.remove('no-scroll');
			var mainTag = document.getElementsByTagName('main')[0];
			if (mainTag) mainTag.classList.remove('increase-zindex');
		},
		modalOpen() {
			let keys = Object.keys(this.showModal);

			for (var index = 0; index < keys.length; index++) {
				let key = keys[index];
				if (this.showModal[key] === true) {
					return true;
				}
			}

			return false;
		},
		shopFilterToggleCategories() {
			this.shopFilterCategories = this.shopFilterCategories ? false : true;
		},
		shopFilterToggleSortBy() {
			this.shopFilterSortBy = this.shopFilterSortBy ? false : true;
		},
		shopFilterToggleProductType() {
			this.shopFilterProductType = this.shopFilterProductType ? false : true;
		},
		loadFaqs() {
			var faqs = document.getElementsByClassName('faq-item');

			for (var index = 0; index < faqs.length; index++) {
				var faq = {
					id: faqs[index].id,
					title: faqs[index].getElementsByTagName('h2')[0].textContent,
					content: faqs[index].getElementsByClassName('para1')[0].textContent,
				};
				this.faqsData.push(faq);
			}
		},
		async fetchFaqs() {
			var tile = document.getElementById('tile-main');
			if (tile) {
				tile.innerHTML =
					'<div id="loader"> <svg><use xlink:href="#logo"></use></svg> <h6>Loading ...</h6> <div>';
				await fetch(window.faqCustomAppFaqApiUrl)
					.then((response) => response.json())
					.then((data) => {
						this.faqList = data;
						this.tileActive = data;

						let hash = this.windowHash.replace('#', '').replaceAll('-', ' ').toLowerCase();

						if (hash) {
							let description = '';
							let showTitle = false;
							let title = '';
							const findArr = (arr, des = null) => {
								for (let i = 0; i < arr.length; i++) {
									if (arr[i].name.toLowerCase().includes(hash)) {
										title = arr[i].name;
										description = arr[i]['description'];
										this.tileActive = arr[i].childs;
										showTitle = true;
										break;
									} else {
										findArr(arr[i]['childs'], arr[i]['description']);
									}
								}
							};
							findArr(data);

							if (showTitle) {
								let text = document.createTextNode(title);

								let tileText = document.createElement('div');
								tileText.className = 'tile-text';

								let btn = document.createElement('button');
								btn.className = 'back-btn';
								btn.innerHTML = 'back';
								let currentPage = window.location.href.substring(
									window.location.href.lastIndexOf('/') + 1,
									window.location.href.indexOf('#')
								);
								btn.onclick = () => window.location.replace('/pages/' + currentPage);

								let titleTile = document.createElement('div');
								titleTile.className = 'title-tile';
								titleTile.id = hash.replaceAll(/ /g, '-').toLowerCase();

								document.getElementById('tile-main').appendChild(titleTile);
								titleTile.appendChild(tileText);
								tileText.appendChild(text);
								titleTile.appendChild(btn);
								document.getElementById('faqs').scrollIntoView();

								description ? this.faqView(description) : '';
							}
							this.faqView(this.tileActive);
						} else {
							this.faqView(this.tileActive);
						}
					})
					.catch((error) => {
						var tile = document.getElementById('tile-main');
						let div = document.createElement('div');
						div.className = 'para1';
						div.innerHTML = 'Something went wrong. Please try agin after some time.';
						// div.innerHTML = error;
						tile.appendChild(div);
					});
				document.getElementById('loader').remove();
			}
		},
		faqView(data) {
			var tile = document.getElementById('tile-main');
			if (Array.isArray(data)) {
				for (i = 0; i < data.length; i++) {
					if (data[i]['is_enable'] == '1') {
						let div = document.createElement('div');
						div.className = 'individual-tiles';

						let a = document.createElement('a');
						let id = data[i]['id'];
						let name = data[i]['name'];
						a.onclick = () => {
							this.tileClick(id, name);
						};

						let tileText = document.createElement('div');
						tileText.className = 'tile-text';

						let text = document.createTextNode(data[i]['name']);

						if (data[i]['icon'] != 'no-icon') {
							let tileIcon = document.createElement('div');
							tileIcon.className = 'tile-icon';

							let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
								use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
							use.setAttributeNS(
								'http://www.w3.org/1999/xlink',
								'xlink:href',
								'#' + data[i]['icon'].toLowerCase()
							);

							a.appendChild(tileIcon);
							tileIcon.appendChild(svg);
							svg.appendChild(use);
						}

						div.appendChild(a);
						a.appendChild(tileText);
						tileText.appendChild(text);
						tile.appendChild(div);
					}
				}
			} else {
				var orders = data;
				const keyword = data.split(' ');
				for (let i = 0; i < keyword.length; i++) {
					if (keyword[i] == '##orders##') {
						if (document.getElementsByClassName('order-tile')[0] == undefined) {
							orders =
								'No orders found! <br> It is possible you are not logged in or you do not have any orders.';
						} else {
							orders = document.getElementById('orders').innerHTML;
						}
					}
				}

				let tileText = document.createElement('div');
				tileText.id = 'description';
				tileText.className = 'mt-5 individual-tiles';
				tileText.innerHTML = orders;
				tile.appendChild(tileText);
			}
		},
		tileClick(id, name) {
			let tile = this.tileActive.filter((i) => i['id'] === id);
			let child = [];

			for (let j = 0, len = tile.length; j < len; j++) {
				child = [...child, tile[j]['childs']];
			}

			if (tile[0].description || child[0].length > 0) {
				let elements = document.querySelectorAll('.individual-tiles');
				for (let i = 0, len = elements.length; i < len; i++) {
					// elements[i].classList.add('hide');
					elements[i].remove();
				}

				let text = document.createTextNode(name);

				let tileText = document.createElement('div');
				tileText.className = 'tile-text';
				tileText.id = name;

				let btn = document.createElement('button');
				btn.className = 'back-btn';
				btn.innerHTML = 'back';
				btn.onclick = () => this.backBtn(id, name);

				let titleTile = document.createElement('div');
				titleTile.className = 'title-tile';
				titleTile.id = name.replaceAll(/ /g, '-').replaceAll('?', '').replaceAll("'", '').toLowerCase();

				document.getElementById('tile-main').appendChild(titleTile);
				titleTile.appendChild(tileText);
				tileText.appendChild(text);
				tileText.appendChild(btn);

				if (tile[0].description) {
					this.faqView(tile[0].description);
				}
				if (child[0].length > 0) {
					this.tileActive = child[0];
					this.faqView(child[0]);
				}
				var titles = document.getElementsByClassName('title-tile');
				var totalTitles = document.getElementsByClassName('title-tile').length;

				window.scrollTo({
					top:
						titles[totalTitles - 1].getBoundingClientRect().top -
						document.body.getBoundingClientRect().top -
						20,
					behavior: 'smooth',
				});
			}
		},
		backBtn(id, name) {
			let elements = document.querySelectorAll('.individual-tiles');
			for (let i = 0, len = elements.length; i < len; i++) {
				elements[i].remove();
			}

			var elements1 = document.querySelectorAll('.title-tile');
			for (let i = elements1.length - 1; i >= 0; i--) {
				if (elements1[i].querySelector('.tile-text').id == name) {
					elements1[i].remove();
					break;
				}
				elements1[i].remove();
			}

			let tileText = document.getElementById('tile-text');
			if (tileText) {
				tileText.innerHTML = '';
				tileText.remove();
			}

			const findArr = (arr, des = null) => {
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].id == id) {
						this.tileActive = arr;
						des ? this.faqView(des) : '';
						break;
					} else {
						findArr(arr[i]['childs'], arr[i]['description']);
					}
				}
			};

			// this.tileActive = this.faqList;
			findArr(this.faqList);
			this.faqView(this.tileActive);
		},
		steppedShopFilterToggleCategories() {
			this.steppedShopFilterToggle = !this.steppedShopFilterToggle;
			if (this.steppedShopFilterToggle) document.addEventListener('click', this.clickOutsideDropdown);
			else document.removeEventListener('click', this.clickOutsideDropdown);
		},
		clickOutsideDropdown(event) {
			var dropdown = document.getElementById('filter-dropdown');
			var button = document.getElementById('filter-dropdown-btn');
			if (button && button.contains(event.target)) return;
			else if (dropdown && !dropdown.contains(event.target)) this.steppedShopFilterToggle = false;
		},
		applySteppedShopFilter(productType) {
			const index = this.steppedShopFilterCategories.indexOf(productType);

			if (index > -1) {
				this.steppedShopFilterCategories.splice(index, 1);
			} else {
				this.steppedShopFilterCategories.push(productType);
			}

			console.log(this.steppedShopFilterCategories);
		},
		isSteppedProductFiltered(productType) {
			const index = this.steppedShopFilterCategories.indexOf(productType);

			if (this.steppedShopFilterCategories.length === 0) {
				return true;
			}

			if (index > -1) {
				return true;
			}

			return false;
		},
		//Stepped Shop
		steppedAddItem(item, plan = false, price = 0, skipStep = 0, e, originalPrice = 0) {
			let priceComp = 0;
			if (!plan) {
				priceComp = price;
			}

			this.steppedItemsSelected.push(item);
			this.steppedItemsSelectedPrice.push(priceComp);
			this.steppedSubscription.push(plan);

			let img = e.currentTarget.getAttribute('data-img');
			let title = e.currentTarget.getAttribute('data-title');
			let sub_title = e.currentTarget.getAttribute('data-sub_title');
			let type = e.currentTarget.getAttribute('data-type');
			let productType = e.currentTarget.getAttribute('data-product-type');
			let pt4VariantId = e.currentTarget.getAttribute('data-2fp');

			let object = {
				id: item,
				img: img,
				title: title,
				sub_title: sub_title,
				price: price,
				original_price: originalPrice,
				type: type,
				product_type: productType,
				pt4_variant: pt4VariantId,
				quantity: 1,
			};

			// add quantity instead duplicate items
			if (this.steppedItemAlreadyExist(object)) {
				this.steppedItemsList.filter((item) => item.id == object.id)[0].quantity =
					this.steppedItemsList.filter((item) => item.id == object.id)[0].quantity + 1;
				console.log(this.steppedItemsList.filter((item) => item.id == object.id));
			} else {
				this.steppedItemsList.push(object);
				//console.log(object, e.currentTarget, this.steppedItemsList)
			}

			if (this.isCampaignApplied && type == 'Pinter') {
				this.steppedTotal = this.steppedTotal + originalPrice / 100;
				this.campDiscTotal += originalPrice / 100 - price / 100;
				console.log(originalPrice + '::' + price + '::' + this.campDiscTotal);
			} else {
				this.steppedTotal = this.steppedTotal + price / 100;
			}

			if (plan !== false) {
				this.steppedTotalSubs = this.steppedTotalSubs + price / 100;
			}

			if (skipStep > 0) {
				this.steppedActiveSteps.push(skipStep + 1);
				this.steppedActiveSteps.push(skipStep + 2);
				this.scrollTo('step-' + (skipStep + 1));
			}
			// Creating Item List For PT4
			//this.create2FPItemList();
			this.calcSteppedTotals();
		},
		steppedRemoveItem(item, subscription = false, cost = 0, originalCost = 0) {
			const removeIndex = this.steppedItemsList.findIndex((idCheck) => idCheck.id == item.id);
			if (item.useVariantId || originalCost / 100 > cost / 100) {
				this.steppedTotal = this.steppedTotal - item.original_price / 100;
				this.campDiscTotal = this.campDiscTotal - item.original_price / 100;
			} else {
				this.steppedTotal = this.steppedTotal - cost / 100;
			}
			if (subscription !== false) {
				this.steppedTotalSubs = this.steppedTotalSubs - cost / 100;
			}
			this.steppedItemsSelected.splice(removeIndex, 1);
			this.steppedItemsSelectedPrice.splice(removeIndex, 1);
			this.steppedSubscription.splice(removeIndex, 1);
			this.steppedItemsList.splice(removeIndex, 1);
			// Creating Item List For PT4
			//this.create2FPItemList();
			this.calcSteppedTotals();
		},
		calcSteppedTotals() {
			let subtotal = 0;
			let discount = 0;
			let total = 0;
			this.steppedItemsList.forEach((item) => {
				if (item.original_price !== 0 && item.original_price !== '0') {
					subtotal = subtotal + (item.original_price / 100) * item.quantity;
					discount = discount + (item.original_price / 100 - item.price / 100) * item.quantity;
				} else {
					subtotal = subtotal + (item.price / 100) * item.quantity;
				}
			});
			total = subtotal - discount;
			console.log('current step totals:' + subtotal + ':' + discount + ':' + total);
			this.steppedTotal = subtotal;
			this.campDiscTotal = discount;
		},
		steppedItemAlreadyExist(steppedItem) {
			let itemLeng = this.steppedItemsList.filter((item) => item.id == steppedItem.id).length;
			if (itemLeng > 0) {
				return true;
			} else {
				return false;
			}
		},
		create2FPItemList() {
			if (this.is2FPApplied && this.hasPinterVariants()) {
				var arrOneOff = [];
				var isOneOff = false;
				var itemList = this.steppedItemsList;
				for (var i = 0; i < itemList.length; i++) {
					if (itemList[i].type == 'Press') {
						isOneOff = true;
						arrOneOff.push(itemList[i]);
					}
				}
				var arrCheapestPrice = arrOneOff;
				if (arrOneOff.length > 1) {
					arrCheapestPrice = arrOneOff.sort(({ price: a }, { price: b }) => a - b);
				}
				this.steppedItems2FPList = [];
				var isCheapDone = false;
				var discount = 0;
				for (var i = 0; i < itemList.length; i++) {
					var temp = {};
					temp.id = itemList[i].id;
					temp.img = itemList[i].img;
					temp.title = itemList[i].title;
					temp.sub_title = itemList[i].sub_title;
					temp.price = itemList[i].price;
					temp.original_price = itemList[i].original_price;
					temp.type = itemList[i].type;
					temp.pt4_variant = itemList[i].pt4_variant;
					if (isOneOff) {
						var cheapestItem = arrCheapestPrice[0];
						if (itemList[i].id == cheapestItem.id && !isCheapDone) {
							temp.original_price = itemList[i].price;
							temp.price = 0;
							isCheapDone = true;
							discount = temp.original_price;
							temp.useVariantId = true;
						}
					}
					this.steppedItems2FPList.push(temp);
				}
				if (discount > 0) this.campDiscTotal = discount / 100;
			} else {
				this.steppedItems2FPList = this.steppedItemsList;
				this.campDiscTotal = 0;
			}
		},
		steppedSkipStep(step) {
			this.steppedActiveSteps.push(step + 1);
			this.scrollTo('step-' + (step + 1));
		},
		deactivateStep(step) {
			const index = this.steppedActiveSteps.indexOf(step);
			if (index > -1) {
				this.steppedActiveSteps.splice(index, 1);
			}
		},
		steppedTab(step = 2, tab = 'one-off') {
			this.steppedTabs['step-' + step] = tab;
		},
		steppedVariants() {
			const variants = [];
			const subscription = this.steppedSubscription;
			const itemList = this.steppedItemsList;

			this.steppedItemsSelected.forEach(function (entry, key) {
				const found = variants.findIndex((variantCheck) => variantCheck.id == entry);
				const itemIndex = itemList.findIndex((item) => item.id == entry);

				if (found >= 0 && itemList[itemIndex].type != 'Pinter' && itemList[itemIndex].type != 'Co-Pinter') {
					variants[found].quantity++;
				} else {
					let variant = {
						id: entry,
						quantity: 1,
					};
					if (subscription[key] !== false) {
						variantSub = { selling_plan: subscription[key] };
						variant = Object.assign(variantSub, variant);
					}
					if (itemList[itemIndex].type == 'Pinter' || itemList[itemIndex].type == 'Co-Pinter') {
						properties = { properties: { Ref: key } };
						variant = Object.assign(properties, variant);
					}

					variants.push(variant);
				}
			});
			return variants;
		},
		cartVariants() {
			const variants = [];
			const subscription = this.cartSubscription;
			const itemList = this.cartItems2FPList;
			this.cartItemsSelected.forEach(function (entry, key) {
				const found = variants.findIndex((variantCheck) => variantCheck.id == entry);
				const itemIndex = itemList.findIndex((item) => item.id == entry);

				if (
					found >= 0 &&
					itemList[itemIndex].type != 'Pinter' &&
					itemList[itemIndex].type != 'Co-Pinter' &&
					!itemList[itemIndex].useVariantId
				) {
					variants[found].quantity++;
				} else {
					let variant = {
						id: entry,
						quantity: itemList[itemIndex].quantity,
						main_price: parseInt(itemList[itemIndex].original_price),
					};
					if (subscription[key] !== false) {
						variantSub = { selling_plan: subscription[key] };
						variant = Object.assign(variantSub, variant);
					}
					if (itemList[itemIndex].type == 'Pinter' || itemList[itemIndex].type == 'Co-Pinter') {
						properties = { properties: { Ref: key } };
						variant = Object.assign(properties, variant);
					}
					if (itemList[itemIndex].useVariantId) {
						variant.id = itemList[itemIndex].pt4_variant;
					}
					variants.push(variant);
				}
			});

			return variants;
		},
		steppedAddToBag(additionalProducts = null) {
			this.isSteppedAddToBagClick = true;
			if (this.hasPaidSubPress && this.steppedHasFreePacks) {
				fetch('/cart/clear.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
				})
					.then((response) => response.json())
					.then((responseData) => {
						this.steppedAddToBagRun();
					})
					.catch((error) => {
						console.error('Error:', error);
					});
			} else {
				this.steppedAddToBagRun(additionalProducts);
			}
		},
		steppedAddToBagRun(additionalProducts = null) {
			this.steppedShopError = false;
			let data = this.steppedVariants();

			if (additionalProducts) {
				data.push(additionalProducts);
			}

			if (!this.hasSteppedErrors) {
				let formData = {
					items: data,
				};
				fetch('/cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(formData),
				})
					.then((response) => {
						if (response.ok) {
							this.cartGetData().then(() => {
								this.cartSetTotal();
								this.cartSetHasPinter();
								this.cartSetPinterBundles();
								location.href = '/cart';
							});
						}
						if (!response.ok) {
							console.error('Error:', response);
							this.steppedShopError = true;
						}
					})
					.catch((error) => {
						console.error('Error:', error);
					});
			}
		},
		steppedCountVariant(variantID) {
			return this.steppedItemsSelected.filter((v) => v === variantID).length;
		},
		steppedVariantByType(type) {
			return this.steppedItemsList.filter((v) => v.type === type);
		},
		clearAllFromCart() {
			return fetch('/cart/clear.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((responseData) => {
					console.log(responseData);
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},
		totalVariantByType(type) {
			let total = 0;
			const variants = this.steppedVariantByType(type);

			if (variants.length > 0) {
				variants.forEach((variant) => {
					total += variant.price;
				});
			}

			return total;
		},
		hasSubscriptionVariants() {
			const variants = this.steppedVariantByType('subscription');

			if (variants.length > 0) {
				return true;
			}

			// For every variant over 1, subtract 100 pence
			return false;
		},
		totalSubscriptionVariants() {
			let total = 0;
			let discount = 0;
			const variants = this.steppedVariantByType('subscription');

			if (variants.length > 0) {
				variants.forEach((variant) => {
					total += variant.price;
				});
			}

			if (variants.length === 2) {
				discount = 1;
			} else if (variants.length > 2) {
				discount = variants.length;
			}

			return total - discount * 100;
		},
		exceededSteppedCountLimit(type, limit) {
			if (limit > 0) {
				const current = this.steppedVariantByType(type);
				return current.length >= limit;
			}

			return false;
		},
		steppedPinterVariantSubNameIs(id, colour) {
			return this.pinterVariantSubName[id] == colour;
		},

		//Global
		scrollTo(div = false) {
			if (div) {
				const element = document.getElementById(div);
				if (element) {
					const scrollToPoint = element.offsetTop;
					window.scroll(0, scrollToPoint);
				}
			}
		},

		//UserUi
		userUiTotalOrderLoad() {
			var orders;

			const ordersToSet = document.getElementsByClassName('data-order-month');
			const ordersToSetKeys = Object.keys(ordersToSet);

			if (ordersToSetKeys.length > 0) {
				ordersToSetKeys.forEach((objectKey) => {
					let orderID = ordersToSet[objectKey].getAttribute('data-order-id');
					let orderTotal = ordersToSet[objectKey].getAttribute('data-order-total');
					let orderQty = ordersToSet[objectKey].getAttribute('data-order-qty');

					console.log(orderID);

					this.userUiTotalChanges[orderID] = false;
					this.userUiTotalNew[orderID] = orderTotal;
					this.userUiTotalCount[orderID] = orderQty;
				});
			}

			return orders;
		},
		userUiTotalChangesCancel(id) {
			this.userUiTotalChanges[id] = true;
		},
		userUiTotalChangesContinue(id) {
			this.userUiTotalChanges[id] = false;
		},
		async userUiTotalChangesSubmit() {
			let userUiBeerSelectedKeys = Object.keys(this.userUiBeerSelected);
			let submit = true;

			userUiBeerSelectedKeys.forEach((orderID) => {
				var variants = this.userUiBeerSelected[orderID];
				var count = this.userUiTotalCount[orderID];
				console.log(variants);
				console.log(count);
				if (variants.length != count) {
					this.userUiTotalChanges[orderID] = true;
					this.userUiTotalCountNew[orderID] = variants.length;
					submit = false;
				}
			});

			if (submit) {
				this.userUiChoicesSubmitted = true;
				console.log('submit the form');
				document.getElementById('data-orders').submit();
			}
		},
		async userUiTotalChangesConfirm(orderID) {
			this.userUiTotalChanges[orderID] = false;
			this.userUiTotalChangesSubmitCheck();
		},
		userUiTotalChangesSubmitCheck() {
			var submit = true;
			this.userUiTotalChanges.forEach((order) => {
				console.log(order);
				if (order == true) {
					submit = false;
				}
			});

			if (submit) {
				this.userUiChoicesSubmitted = true;
				console.log('submit the form');
				document.getElementById('data-orders').submit();
			}
		},
		userUiRemoveBeer(variantID, orderID) {
			const removeIndex = this.userUiBeerSelected[orderID].indexOf(variantID);
			this.userUiBeerCount[orderID]--;
			this.userUiBeerSelected[orderID].splice(removeIndex, 1);

			//Also update any selections AFTER this order
			let ordersAfter = Object.keys(this.userUiBeerSelected).filter((orderKey) => orderKey > orderID);
			ordersAfter.forEach((orderKey) => {
				const removeIndex = this.userUiBeerSelected[orderKey].indexOf(variantID);
				this.userUiBeerCount[orderKey]--;
				this.userUiBeerSelected[orderKey].splice(removeIndex, 1);
			});
		},
		userUiAddBeer(variantID, orderID) {
			if (orderID) {
				if (!this.userUiBeerSelected[orderID]) {
					this.userUiBeerCount[orderID] = 1;
					this.userUiBeerSelected[orderID] = [];
					this.userUiBeerSelected[orderID].push(variantID);
				} else {
					this.userUiBeerCount[orderID]++;
					this.userUiBeerSelected[orderID].push(variantID);
				}

				//Also update any selections AFTER this order
				let ordersAfter = Object.keys(this.userUiBeerSelected).filter((orderKey) => orderKey > orderID);
				ordersAfter.forEach((orderKey) => {
					if (!this.userUiBeerSelected[orderKey]) {
						this.userUiBeerCount[orderKey] = 1;
						this.userUiBeerSelected[orderKey] = [];
						this.userUiBeerSelected[orderKey].push(variantID);
					} else {
						this.userUiBeerCount[orderKey]++;
						this.userUiBeerSelected[orderKey].push(variantID);
					}
				});
			}
		},
		userUiCountVariant(variantID, orderID) {
			if (this.userUiBeerSelected[orderID]) {
				return this.userUiBeerSelected[orderID].filter((v) => v === variantID).length;
			}
			return 0;
		},
		userUiLoadData() {
			const ordersToSet = document.getElementsByClassName('user-ui-order');
			const ordersToSetKeys = Object.keys(ordersToSet);

			if (ordersToSetKeys.length > 0) {
				ordersToSetKeys.forEach((objectKey) => {
					let orderID = ordersToSet[objectKey].getAttribute('data-orderID');
					let currentData = JSON.parse(ordersToSet[objectKey].getAttribute('data-currentData'));
					let variantKeys = Object.keys(currentData);
					this.userUiBeerSelected[orderID] = [];
					this.userUiBeerCount[orderID] = 0;

					if (variantKeys.length > 0) {
						variantKeys.forEach((objectSubKey) => {
							for (let step = 0; step < currentData[objectSubKey]; step++) {
								this.userUiBeerSelected[orderID].push(Number(objectSubKey));
								this.userUiBeerCount[orderID]++;
							}
						});
					}
				});
			}
		},
		updateCartChkBtn() {
			if (this.is2FPApplied) {
				this.cartLoading = true;
				this.clearAllFromCart()
					.then((data) => {
						let cartVars = this.cartVariants();
						this.cartData = [];
						console.log(cartVars);
						let formData = {
							items: cartVars,
						};
						fetch('/cart/add.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify(formData),
						})
							.then((response) => {
								if (response.ok) {
									console.log(response);
									this.cartLoading = false;
									return true;
								} else {
									console.error('Error:', response);
									this.cartLoading = false;
									return false;
								}
							})
							.catch((error) => {
								console.error('Error:', error);
								this.cartLoading = false;
								return false;
							});
					})
					.catch((error) => {
						return false;
					});
			} else {
				return true;
			}
		},
		validateGift(formSubmit) {
			if (
				this.cartGiftOptionSelected ||
				document.getElementById('toggle-on').checked ||
				document.getElementById('toggle-off').checked
			) {
				return true;
			} else {
				var giftSelection = document.getElementsByClassName('basket__gifting')[0];
				giftSelection.insertAdjacentHTML(
					'afterend',
					'<div class="alert flavour-red-3 rounded" style="margin-top: 10px;"><div class="alert__inner">Please select a gift option.</div></div>'
				);
				formSubmit.preventDefault();
			}
		},
		getParameterByName(name, url = window.location.href) {
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) return false;
			if (!results[2]) return false;
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		appRedirect() {
			let url_string = window.location.href;
			let url = new URL(url_string);
			let allowtracking = url.searchParams.get('allowtracking');
			let nextUrl = url.searchParams.get('next');
			if (allowtracking) {
				this.eraseCookie('cookieconsent_status1');
				this.eraseCookie('cookieconsent_preferences_disabled');
				if (allowtracking == 1) {
					// if app tracking in iOS enabled
					this.setCookie('cookieconsent_status1', 'accept_all', 30000);
					this.setCookie('cookieconsent_preferences_disabled', '', 30000);
				}

				if (allowtracking == 0) {
					// disable marketing cookies
					this.setCookie('cookieconsent_status1', 'accept_selected', 30000);
					this.setCookie('cookieconsent_preferences_disabled', 'marketing', 30000);
				}
			}

			if (nextUrl) {
				window.location.replace(nextUrl);
			}
		},
		setJWT() {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const jwt = urlParams.get('jwt');

			if (jwt != undefined) {
				this.setCookie('jwt', jwt, 1);
			}
		},
		forumRedirect() {
			if (typeof cId !== 'undefined') {
				const jwt = this.getCookie('jwt');
				if (jwt != undefined) {
					this.eraseCookie('jwt');
					window.location.href = window.pinterServiceVanillaConnectApiUrl + cId + '/?jwt=' + jwt;
				}
			}
		},
		setCookie(name, value, days) {
			let expires = '';
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = '; expires=' + date.toUTCString();
			}
			document.cookie = name + '=' + (value || '') + expires + '; Domain=.pinter.co.uk; path=/';
		},
		getCookie(name) {
			let nameEQ = name + '=';
			let ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},
		eraseCookie(name) {
			document.cookie = name + '=; Max-Age=-99999999;';
		},
		// Navigation between login and forgot password */
		loginNavigation(val) {
			sessionStorage.setItem('nav_login', val);
			location.reload();
		},
		loginVerifyNavigation() {
			var tempStorage = sessionStorage.getItem('nav_login');
			if (tempStorage == null) return this.accountLogin;
			else return tempStorage;
		},
		// Navigation ends
		// Snowplow begins
		snowPlowTrackCartActivity() {
			if (!window.snowplow) {
				return;
			}
			let previousItemCount = parseInt(sessionStorage.getItem(this.previousItemCount), 10);
			let previousItems = JSON.parse(sessionStorage.getItem(this.previousItems));
			if (!previousItemCount) {
				previousItemCount = 0;
			}
			if (!previousItems) {
				previousItems = [];
			}

			if (this.cartTotalItems > previousItemCount) {
				let addedItems = [];

				this.cartData.items.forEach((item) => {
					if (previousItems == null || previousItems.length == 0) {
						addedItems.push(item);
					} else {
						let found = false;
						previousItems.forEach((lineItem) => {
							if (lineItem.key === item.key) {
								found = true;
							}
						});
						if (!found) {
							addedItems.push(item);
						}
					}
				});

				addedItems.forEach((item) => {
					window.snowplow('trackAddToCart', {
						sku: item.sku,
						name: item.product_title,
						category: item.product_type,
						unitPrice: item.final_line_price / 100,
						quantity: item.quantity,
						currency: this.cartData.currency,
					});
				});
			}

			if (this.cartTotalItems < previousItemCount) {
				let removedItems = [];

				previousItems.forEach((lineItem) => {
					if (this.cartData.items.length == 0) {
						removedItems.push(lineItem);
					} else {
						let found = false;
						this.cartData.items.forEach((item) => {
							if (lineItem.key === item.key) {
								found = true;
							}
						});
						if (!found) {
							removedItems.push(lineItem);
						}
					}
				});

				removedItems.forEach((item) => {
					window.snowplow('trackRemoveFromCart', {
						sku: item.sku,
						name: item.product_title,
						category: item.product_type,
						unitPrice: item.final_line_price / 100,
						quantity: item.quantity,
						currency: this.cartData.currency,
					});
				});
			}
			sessionStorage.setItem(this.previousItemCount, this.cartData.item_count);
			sessionStorage.setItem(this.previousItems, JSON.stringify(this.cartData.items));
		},
		// Snowplow ends

		// pricing funnel campaign
		async checkPricingCampaign() {
			//get pricing_campaign value from local storage
			let pricing_campaign = this.getWithExpiry('pricing_campaign');

			//if pricing_campaign not set, get it from query string or call api and set it randomly
			if (
				pricing_campaign === null ||
				(pricing_campaign !== 'PT1' &&
					pricing_campaign !== 'PT2' &&
					pricing_campaign !== 'PT3' &&
					pricing_campaign !== 'PT4')
			) {
				await fetch(window.midServicePricingFunnelApiUrl)
					.then((response) => response.json())
					.then((data) => {
						// set local storage for random campaign code
						this.setLsWithExpiry('pricing_campaign', data, 30);
						this.snowplow(data);

						//reset price as local storage
						if (window.productCardList && window.productCardList.length > 0) {
							for (var i = 0; i < productCardList.length; i++) {
								//reset price for every product cards on collection page
								this.setProductCardPinterPrice(productCardList[i]);
							}
						}
						if (window.productObj || this.currProdVarLs) {
							this.setBuyControlsPinterPrice();
						}
					})
					.catch((error) => {
						console.log(error);
					});
			} else {
				//if utm_campaign set in query string, use it
				this.setLsWithExpiry('pricing_campaign', pricing_campaign, 30);
				this.snowplow(pricing_campaign);
			}
		},
		setLsForPricingFunnelCamp() {
			//let utm_source_val = this.getParameterByName("utm_source");
			let utm_campaign_val = 'PT3'; //this.getParameterByName("utm_campaign");

			// override pricing variant exist or not
			if (
				utm_campaign_val != null &&
				(utm_campaign_val === 'PT1' ||
					utm_campaign_val === 'PT2' ||
					utm_campaign_val === 'PT3' ||
					utm_campaign_val === 'PT4')
			) {
				// set local storage as per querstring
				this.setLsWithExpiry('pricing_campaign', utm_campaign_val, 30);
				this.snowplow(utm_campaign_val);
			} else {
				// call random api to set local storage
				this.checkPricingCampaign();
			}
		},
		snowplow(utm_campaign) {
			setTimeout(() => {
				try {
					if (!window.snowplow) {
						return;
					}
					window.snowplow('trackSelfDescribingEvent', {
						event: {
							schema: 'iglu:co.uk.pinter/experiment_entered/jsonschema/1-0-0',
							data: {
								experiment_name: 'pricing_funnel',
								experiment_variant: utm_campaign,
							},
						},
					});
				} catch (error) {
					console.log(error);
				}
			}, 500);
		},
		setLsWithExpiry(key, value, ttl) {
			// for expiry in day
			const minute = 1000 * 60;
			const hour = minute * 60;
			const day = hour * 24;

			const now = new Date();

			// `item` is an object which contains the original value
			// as well as the time when it's supposed to expire
			const item = {
				value: value,
				expiry: now.getTime() + ttl * day,
			};
			localStorage.setItem(key, JSON.stringify(item));
		},
		getWithExpiry(key) {
			const itemStr = localStorage.getItem(key);

			// if the item doesn't exist, return null
			if (!itemStr) {
				return null;
			}

			const item = JSON.parse(itemStr);
			const now = new Date();

			// compare the expiry time of the item with the current time
			if (now.getTime() > item.expiry) {
				// If the item is expired, delete the item from storage
				// and return null
				localStorage.removeItem(key);
				return null;
			}
			return item.value;
		},
		setBuyControlsPinterPrice() {
			if (this.currProdVarLs != null) {
				var currProdVarLsJson = JSON.parse(this.currProdVarLs);
				if (document.getElementById('buy-controls-price')) {
					document.getElementById('buy-controls-price').innerHTML =
						'£' + (currProdVarLsJson.price / 100).toFixed(2);
				}
				if (currProdVarLsJson.title === 'PT2' || currProdVarLsJson.title === 'PT3') {
					if (document.getElementById('buy-controls-discount')) {
						document.getElementById('buy-controls-discount').className = 'discount';
					}
				}
			} else if (window.productObj != null) {
				var LsPricingCampaign = localStorage.getItem('pricing_campaign');
				if (LsPricingCampaign != '' && LsPricingCampaign != null) {
					LsPricingCampaign = JSON.parse(LsPricingCampaign);
					let campVar = window.productObj.filter(function (item) {
						return item.title == LsPricingCampaign.value;
					});
					if (document.getElementById('buy-controls-price')) {
						document.getElementById('buy-controls-price').innerHTML =
							'£' + (campVar[0].price / 100).toFixed(2);
					}
					if (LsPricingCampaign.value === 'PT2' || LsPricingCampaign.value === 'PT3') {
						if (document.getElementById('buy-controls-discount')) {
							document.getElementById('buy-controls-discount').className = 'discount';
						}
					}
				}
			}
		},
		setProductCardPinterPrice(productCardObj) {
			if (productCardObj != null && productCardObj.type === 'Pinter') {
				var LsPricingCampaign = localStorage.getItem('pricing_campaign');
				if (LsPricingCampaign != '' && LsPricingCampaign != null) {
					LsPricingCampaign = JSON.parse(LsPricingCampaign);
					var campVar = productCardObj.variants.filter(function (item) {
						return item.title == LsPricingCampaign.value;
					});
					//console.log(campVar.length);
					if (campVar.length > 0) {
						campVar[0].productId = productCardObj.id;
						console.log(campVar[0]);
						var priceHTML = (document.querySelector(
							'[data-pId="' + productCardObj.id + '"] .card-product__price .para2'
						).innerHTML = '£' + (campVar[0].price / 100).toFixed(2));
					}
					if (LsPricingCampaign.value === 'PT2' || LsPricingCampaign.value === 'PT3') {
						var selector = 'card-controls-discount-' + productCardObj.id;
						if (document.getElementById(selector)) {
							document.getElementById(selector).className = 'discount';
						}
					}
				}
			}
		},
		setProductVariantForPinterPage(elem) {
			let pCardHref = elem.currentTarget.href;
			let currPid = elem.currentTarget.parentElement.getAttribute('data-pId');
			let campProduct = window.productCardList.filter(function (item) {
				return item.id == currPid;
			});
			//console.log(campProduct);
			let LsPricingCampaign = localStorage.getItem('pricing_campaign');
			if (LsPricingCampaign != '' && LsPricingCampaign != null) {
				LsPricingCampaign = JSON.parse(LsPricingCampaign);
				var currClickedVar = campProduct[0].variants.filter(function (item) {
					return item.title == LsPricingCampaign.value;
				});
				//console.log(currClickedVar[0]);
				if (currClickedVar[0] != null && currClickedVar[0] != undefined) {
					localStorage.setItem('currClickVariant', JSON.stringify(currClickedVar[0]));
				} else {
					localStorage.removeItem('currClickVariant');
				}
			}
			window.location.href = pCardHref;
		},
		makeCheapestPressFreeFromCartItms(cartItemsObjArr) {
			let tempPressItemsArr = [];
			let tempCartItemsObjArr = cartItemsObjArr.filter((item) => item.type == 'Press');
			let sortedCartItemsObjArr = tempCartItemsObjArr;
			if (tempCartItemsObjArr.length > 0) {
				tempPressItemsArr = sortedCartItemsObjArr.sort(function (a, b) {
					return a.price - b.price;
				});
				let freePresCount = 0;
				for (var i = 0; i < tempCartItemsObjArr.length; i++) {
					if (tempCartItemsObjArr[i].title == tempPressItemsArr[0].title && freePresCount < 1) {
						// tempCartItemsObjArr[i].price= 0;
						tempCartItemsObjArr[i].useVariantId = true;
						freePresCount++;
					} else {
						tempCartItemsObjArr[i].useVariantId = false;
					}
				}
			}
			return tempCartItemsObjArr;
		},
		makeCheapestPressFreeFromCartPage(cartItemsObjArr) {
			let tempPressItemsArr = [];
			let tempCartItemsObjArr = cartItemsObjArr.filter((item) => item.product_type == 'Press');
			let sortedCartItemsObjArr = tempCartItemsObjArr;
			if (tempCartItemsObjArr.length > 0) {
				tempPressItemsArr = sortedCartItemsObjArr.sort(function (a, b) {
					return a.price - b.price;
				});
				for (var i = 0; i < tempCartItemsObjArr.length; i++) {
					if (tempCartItemsObjArr[i].title == tempPressItemsArr[0].title) {
						// tempCartItemsObjArr[i].price= 0;
						tempCartItemsObjArr[i].useVariantId = true;
					} else {
						tempCartItemsObjArr[i].useVariantId = false;
					}
				}
			}
			return tempCartItemsObjArr;
		},
	},
});

app.component('modal', {
	template: '#modal-template',
	props: {
		modalFullScreen: Boolean,
		modalClassText: Boolean,
		id: String,
	},
	data() {
		return {
			modal: undefined,
			wrapper: undefined,
		};
	},
	beforeDestroy() {
		this.wrapper.removeEventListener('click', this.clickOutside);
	},
	mounted() {
		this.modal = document.getElementById('modal-' + this.id);
		this.wrapper = this.modal.closest('.modal-wrapper');
		this.wrapper.addEventListener('click', this.clickOutside);
	},
	methods: {
		clickOutside(e) {
			if (this.modal && !this.modal.contains(e.target)) {
				this.$emit('close');
			}
		},
	},
});

app.mount('#app');
